// @ts-nocheck
import BillingFollowupDashboardNotice from "./_components/BillingFollowupDashboardNotice";
import ClientChecklistCell from './_components/ClientChecklistCell';
import { useClientChecklists } from './_hooks/useClientChecklists';
import ClientOnboardingDashboardNotice from './_components/ClientOnboardingDashboardNotice';
import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { lazy } from "react";
import { useState } from "react";
import dayjs from "dayjs";
import lodash from "lodash";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Box,
  Button,
  Input,
  InputAdornment,
  Typography,
  Pagination,
  PaginationItem,
  useMediaQuery,
  MenuItem,
  Select,
  Tooltip,
  Popover,
  Modal,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Chip,
  Switch,
  Snackbar,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import WestIcon from "@mui/icons-material/West";
import AddPlus from "../../assets/images/add-plus.svg";
import Show from "../../assets/images/Show.svg";
import TableBody from "@mui/material/TableBody";
import { useTheme } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import {
  ArrowBack,
  ArrowForward,
  Check,
  Clear,
  Close,
  Info,
  Save,
  Search,
} from "@mui/icons-material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import states from "us-state-codes";
import {
  archiveEventAction,
  deleteEventAction,
  getAllEventsAction,
  updateEventFromDashboardAction,
} from "../../store/actions/eventRequest";
import { duplicateMarkedLabel, toggleDuplicateFlow } from "../../store/actions/eventDuplicate";
import { confirmAndCloseCreateEventAction } from "../../store/actions/createEvent";
import { convertDate } from "../../utils/methods/formatters";
import AssignClientModal from "../event-request/components/AssignClientModal";
import "../event-request/EventRequests.css";
import LoadingOverlay from "../../components/Custom/LoadingOverlay";

import { getCssVariableHandler } from "../../utils/styles/getCssVariables";
const CreateEvent = lazy(() => import("../create-event/CreateEvent"));
import { CongratulationsNavButtonsVariant2 } from "../create-event/components/event-details/EventDetails";

// icons
// import EditEventModal from "../../components/EditEventModal";
import { isUserRole, isActiveRole } from "../../utils/methods/storeFunc";
import { USER_ROLES } from "../../staticData/userRoles";
import ReusableParentContainer from "../../components/Custom/ReusableParentContainer";
import EditNoteModal from "./EditNoteModal";
import GenericTransparentBtn from "../../components/Custom/GenericTransparentBtn";
import { ALERT_DIALOG } from "../../store/constants/auth";
import { CustomInput } from "../../components/Custom/Input";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { CustomDatePicker } from "../../components/Custom/DatePicker";
import { CalendarMonth, Edit } from "@mui/icons-material";
import { getUniversalDateTimeFormat } from "../../utils/methods/universalDateTimeFormat";
import { inputRegex } from "../../utils/constants/inputRegex";
import { buildShareableUrl } from "../../api/share-token";
import RowsPerPageDropdown from "../../components/Custom/Pagination/RowsPerPageDropdown";
import { rowsPerPageInit } from "../../utils/constants/paginationConstants";
import { ClientTool } from "../../components/Tooltip/ClientTool";
import RightClick from "../event-details/components/additionalComponents/RightClick";
import {
  dashboardRowBackgroundColors,
  getRowStrips,
  handleEventContextMenu,
  onSubmitFormNoAction,
} from "../../utils/methods/eventUtils";
import { alertDialogAciton } from "../../store/actions/auth";
import EditEventModal from "../event-request/components/EditEventModal";
import { CustomDialog } from "../../components/Dialog/CustomDialog";
import DashboardFilter from "../../components/Filter/DashboardFilters";
import { getDashboardEventsAction } from "../../store/actions/event/dashboar";
import { ClearAllTextButton } from "../../components/Filter/ClearAllTextButton";
import { minHeight, Stack } from "@mui/system";
import { rejectEventAction } from "../../store/actions/estimate";
import TableColumnManager from "../../components/TableColumnManager/TableColumnManager";
import { setTableColumnVisibility } from "../../store/actions/tableColumnVisibility";
import { FRONTEND_CONFIG } from "../../utils/constants/configs";
import { useDashboardFilters } from "../../customHooks/useDashboardFilters";
import {
  extractFiltersFromState,
  applyFiltersToState,
  hasFiltersChanged,
  compareObjects,
} from "../../utils/dashboardFiltersUtils";
import {
  getHeaderStyles,
  getBodyStyles,
  getStickyHeaderStyles,
  getStickyBodyStyles,
  getRowBackground,
  tableRowConfig,
  defaultHeaderStyles,
} from "./dashboardTableConfig";
import DashboardColorsLegend from "./_components/DashboardColorsLegend";
import { eventStatusLabel, isCancelledEvent } from "../../utils/methods/eventPresentation";
import { useColumnWidths } from "./_hooks/useColumnWidths";
import { useMeasuredWidth } from "./_hooks/useMeasuredWidth";
import ResizeHandle from "./_components/ResizeHandle";
import StatusHeaderFilter from "./_components/StatusHeaderFilter";
import SortableHeaderLabel from "./_components/SortableHeaderLabel";
import { SORTABLE_FIELDS } from "./_components/dashboardSortFields";
import CoordinatorAvatars from "./_components/CoordinatorAvatars";
import CoordinatorHeaderFilter from "./_components/CoordinatorHeaderFilter";
import CoordinatorFilterPanel from "./_components/CoordinatorFilterPanel";
import {
  EMPTY_COORDINATOR_FILTER,
  coordinatorDisplayName,
  coordinatorFilterToParams,
  coordinatorSlotsForWidth,
  isCoordinatorFilterActive,
} from "./_components/dashboardCoordinators";
import {
  DraggableHeaderCell,
  StyledSelect,
  StyledTableCell,
  StyledTableRow,
  StyledPaginationItem,
} from "./_components/dashboardStyles";
import OrderedCells from "../../components/Table/OrderedCells";
import ColumnReorderProvider from "../../components/Table/ColumnReorderProvider";
import { useColumnOrder } from "../../customHooks/useColumnOrder";
import DashboardViewToggle from "./_components/DashboardViewToggle";
import DashboardFinance from "./finance/DashboardFinance";
import { defaultFinanceControls } from "./finance/financialDashboard.utils";
import { FinanceToolbarFilters, FinanceFilterSummary } from "./finance/FinanceToolbar";
import DashboardCalendar from "./_components/DashboardCalendar";
import { useDashboardView } from "./_hooks/useDashboardView";
import { useCalendarEvents } from "./_hooks/useCalendarEvents";
import DashboardOverview from "./overview/DashboardOverview";
import EventTypeFilterSection from "./_components/EventTypeFilterSection";
import EventTypeBadge from "./_components/EventTypeBadge";
import { showPageFor } from "./_utils/showPage";
import {
  DEFAULT_EVENT_TYPES,
  EVENT_TYPE_OPTIONS,
  eventTypesToParams,
  isDefaultEventTypes,
  sanitizeEventTypes,
} from "./_components/eventTypes";
import { monthGridRange } from "../../utils/methods/calendarLayout";
import QuickViewBar from "./_components/QuickViewBar";
import HighlightStar from "./_components/HighlightStar";
import { duplicatesToParams, quickViewToParams, sanitizeQuickView } from "./_components/quickViews";
import type { QuickView } from "./_components/quickViews";
import { useHighlights } from "./_hooks/useHighlights";
import { NEON } from "./overview/boardStyles";

const Dashboard = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { state } = useLocation();
  const { widths, setWidth, resetWidth, resetAllWidths } = useColumnWidths();
  const eventStatusHeaderRef = useRef(null);
  const [measuredEventStatusWidth, setMeasuredEventStatusWidth] =
    useState(null);

  useEffect(() => {
    const node = eventStatusHeaderRef.current;
    if (!node || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setMeasuredEventStatusWidth(Math.round(entry.contentRect.width));
      }
    });
    ro.observe(node);
    return () => ro.disconnect();
  }, []);

  const effectiveEventStatusWidth =
    widths["eventStatus"] ?? measuredEventStatusWidth ?? undefined;

  // "Coordinators" column: how many avatars fit is derived from the header
  // cell width (one observer for the whole column, not one per row).
  const [coordinatorsHeaderRef, coordinatorsHeaderWidth] = useMeasuredWidth();
  const coordinatorSlots = useMemo(
    () =>
      coordinatorSlotsForWidth(
        widths["coordinators"] ?? coordinatorsHeaderWidth ?? null,
      ),
    [widths, coordinatorsHeaderWidth],
  );

  const getColumns = () => {
    return [
      { id: "eventStatus", label: "Status", defaultVisible: true },
      { id: "eventName", label: "Show", defaultVisible: true },
      { id: "venueState", label: "State", defaultVisible: true },
      { id: "venueCity", label: "City", defaultVisible: true },
      ...(!isActiveRole(USER_ROLES.CLIENT)
        ? [{ id: "client", label: "Client", defaultVisible: true }]
        : []),
      { id: "venue", label: "Venue", defaultVisible: true },
      ...(!isActiveRole(USER_ROLES.CLIENT)
        ? [{ id: "sowStatus", label: "Event Status", defaultVisible: true }]
        : []),
      { id: "eventStart", label: "Start Date", defaultVisible: true },
      { id: "eventEnd", label: "End Date", defaultVisible: true },
      { id: "daysTillStart", label: "Starts In", defaultVisible: true },
      { id: "daysTillEnd", label: "Ends In", defaultVisible: true },
      { id: "contact", label: "Contact", defaultVisible: true },
      ...(!isActiveRole(USER_ROLES.CLIENT)
        ? [{ id: "clientOnboarding", label: "Client onboarding", defaultVisible: true }]
        : []),
      { id: "coordinators", label: "Coordinators", defaultVisible: true },
      { id: "notes", label: "Notes", defaultVisible: true },
      ...(!isActiveRole(USER_ROLES.COORDINATOR)
        ? [{ id: "estimate", label: "Estimate", defaultVisible: true }]
        : []),
      { id: "clientPo", label: "Client's PO#", defaultVisible: true },
      ...(!isActiveRole(USER_ROLES.COORDINATOR)
        ? [
            {
              id: "clientDepositInvoice",
              label: "Client's Deposit Invoice",
              defaultVisible: true,
            },
          ]
        : []),
      ...(!isActiveRole(USER_ROLES.COORDINATOR)
        ? [
            {
              id: "clientFinalInvoice",
              label: "Client's Final Invoice",
              defaultVisible: true,
            },
          ]
        : []),
      ...(!isUserRole(USER_ROLES.CLIENT, USER_ROLES.COORDINATOR)
        ? [{ id: "pl", label: "P&L", defaultVisible: true }]
        : []),
      ...(!isUserRole(USER_ROLES.CLIENT, USER_ROLES.COORDINATOR)
        ? [
            {
              id: "invoicedAmount",
              label: "Invoiced Amount",
              defaultVisible: true,
            },
          ]
        : []),
    ];
  };

  // tableColumns holds the local visibility that drives the render.
  // Previously it was always initialized with defaults (`getColumns()`) and
  // ignored whatever was already in Redux/localStorage — so navigating away
  // and back made all columns reappear. Now it hydrates from redux-persist
  // first (sync access via localStorage on init to avoid a flash of "all
  // visible"), and the useEffect below keeps syncing if Redux changes.
  const [tableColumns, setTableColumns] = useState(() => {
    const cols = getColumns();
    try {
      const raw = localStorage.getItem("persist:root");
      if (raw) {
        const root = JSON.parse(raw);
        const tcvRaw = root?.tableColumnVisibility;
        if (tcvRaw) {
          const tcv = JSON.parse(tcvRaw);
          const saved = tcv?.columnVisibility?.["dashboard-events-table"];
          if (saved && typeof saved === "object") {
            return cols.map((c) => ({
              ...c,
              visible: saved[c.id] ?? c.defaultVisible ?? true,
            }));
          }
        }
      }
    } catch {
      /* fall back to defaults */
    }
    return cols;
  });

  // User-defined column order (drag a header onto another). Saved in
  // localStorage only — deliberately not part of the backend "saved filters".
  const defaultColumnIds = useMemo(
    () => tableColumns.map((c) => c.id),
    [tableColumns],
  );
  const {
    order: columnOrder,
    moveColumn,
    resetOrder: resetColumnOrder,
  } = useColumnOrder("dashboardColumnOrder.v1", defaultColumnIds);
  // The Status column is only pinned (sticky left) while it is the first one.
  const isStatusFirstColumn = columnOrder[0] === "eventStatus";

  // Generate initialData with dynamic hiddenColumns based on user role's available columns
  const initialData = useMemo(() => {
    const columns = getColumns();
    const hiddenColumns = columns.reduce((acc, column) => {
      acc[column.id] = true;
      return acc;
    }, {});

    return {
      search: "",
      sortOrder: "",
      sortField: "",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      searchFilters: [],
      rowsPerPage: 25,
      hiddenColumns,
    };
  }, []);

  // static data start...
  const gustoTypes = React.useMemo(() => {
    return [
      {
        label: "Complete",
        value: "Complete",
      },
      {
        label: "Invites Sent",
        value: "Invites Sent",
      },
      {
        label: "Missing Info",
        value: "Missing Info",
      },
      {
        label: "Invoices Rcvd",
        value: "Invoices Rcvd",
      },
      {
        label: "Cancelled",
        value: "Cancelled",
      },
      {
        label: "Incomplete",
        value: "Incomplete",
      },
      {
        label: "Paid",
        value: "Paid",
      },
      {
        label: "POs Pending",
        value: "POs Pending",
      },
      {
        label: "Send Invites",
        value: "Send Invites",
      },
      {
        label: "On Hold",
        value: "On Hold",
      },
      {
        label: "Issue POs",
        value: "Issue POs",
      },
      {
        label: "Reminders Sent",
        value: "Reminders Sent",
      },
      {
        label: "POs Created",
        value: "POs Created",
      },
      {
        label: "Pending",
        value: "Pending",
      },
    ];
  }, []);

  const sowTypes = React.useMemo(() => {
    return [
      {
        label: "Sent to Contractor",
        value: "Sent to Contractor",
      },
      {
        label: "Pending Approval",
        value: "Pending Approval",
      },
      {
        label: "Waiting EC Conf",
        value: "Waiting EC Conf",
      },
      {
        label: "Cancelled",
        value: "Cancelled",
      },
      {
        label: "SOWs In Progress",
        value: "SOWs In Progress",
      },
    ];
  }, []);

  const commisionTypes = React.useMemo(() => {
    return [
      {
        label: "Calculated",
        value: "Calculated",
      },
      {
        label: "Paid",
        value: "Paid",
      },
      {
        label: "NA",
        value: "NA",
      },
      {
        label: "Cancelled",
        value: "Cancelled",
      },
      {
        label: "Conf Needed",
        value: "Conf Needed",
      },
      {
        label: "Invoice Rcvd",
        value: "Invoice Rcvd",
      },
      {
        label: "Partial Pay-2 ECs",
        value: "Partial Pay-2 ECs",
      },
    ];
  }, []);

  const noteTypes = React.useMemo(() => {
    return [
      {
        label: "did not respond",
        value: "did not respond",
      },
      {
        label: "going with dif. vendor",
        value: "going with dif. vendor",
      },
      {
        label: "Has not responded.",
        value: "Has not responded.",
      },
      {
        label: "out of client price range",
        value: "out of client price range",
      },
      {
        label: "LF",
        value: "LF",
      },
      {
        label: "Socorra",
        value: "Socorra",
      },
      {
        label: "Unknown reason",
        value: "Unknown reason",
      },
    ];
  }, []);

  const showEditNoteModalInit = React.useMemo(() => {
    return {
      show: false,
      content: "",
      eventId: "",
    };
  }, []);

  const filterByOptions = useMemo(() => {
    return isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)
      ? [
          {
            label: "Ongoing",
            subSort: "asc",
            value: "ongoing",
          },
          {
            label: "Upcoming",
            subSort: "asc",
            value: "upcoming",
          },
          {
            label: "Past",
            subSort: "desc",
            value: "past",
          },
          {
            label: "Cancelled",
            subSort: "asc",
            value: "cancelled",
          },
          {
            label: "Archived",
            subSort: "desc",
            value: "archived",
          },
        ]
      : [
          {
            label: "Ongoing",
            subSort: "asc",
            value: "ongoing",
          },
          {
            label: "Upcoming",
            subSort: "asc",
            value: "upcoming",
          },
          {
            label: "Past",
            subSort: "asc",
            value: "past",
          },
        ];
  }, []);

  const initialFiltersDates = useMemo(() => {
    return {
      status: false,
      startDate: "",
      endDate: "",
    };
  }, []);

  // form schema...
  const initialValues = React.useMemo(() => {
    return [
      {
        eventId: "",
        eventGustoStatus: "",
        eventNotes: "",
        eventDepositInvoice: "",
        eventClientSentPO: "",
        isEventClientSentPOBeingEdited: false,
      },
    ];
  }, []);
  // form schema...
  // static data end...

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [isFilterInitialised, setIsFilterInitialised] = React.useState(false);
  const resetColumnBtnRef = React.useRef(null);
  const filtersAppliedRef = React.useRef(false);
  const skipNextFetchRef = React.useRef(false);

  // Selectors start...
  const auth = useSelector((state) => state.auth);
  const { archiveLoading } = useSelector((state) => state.eventRequest);
  const {
    dashboard,
    currentPage,
    totalPages,
    isLoading,
    searchString,
    searchBy: searchByRedux,
    rowsPerPage: rowsPerPageRedux,
    filtersDate: filtersDateRedux,
    coordinatorFilter: coordinatorFilterRedux,
    eventTypes: eventTypesRedux,
  } = useSelector((state) => state?.dashboard);
  // Selectors end...

  // State variables start...
  const [rows, setRows] = React.useState([]);
  const [page, setPage] = React.useState(currentPage || 1);
  const [rowsPerPage, setRowsPerPage] = React.useState(
    rowsPerPageRedux || rowsPerPageInit,
  );
  const [open, setOpen] = useState(false);
  const [filterParams, setFilterParams] = useState({
    search: searchString || "",
    sortOrder: "",
    sortField: "",
  });
  const [filterDates, setFilterDates] = useState(
    filtersDateRedux ?? initialFiltersDates,
  );
  // "Coordinators" column filter: { selected: [{_id, fullName, ...}], match: "any" | "all" }
  const [coordinatorFilter, setCoordinatorFilter] = useState(
    coordinatorFilterRedux ?? EMPTY_COORDINATOR_FILTER,
  );
  // Effect dependency: refetch only when the params sent to the API change
  // (e.g. flipping Any/All with nothing selected changes nothing server-side).
  const coordinatorFilterKey = useMemo(
    () => JSON.stringify(coordinatorFilterToParams(coordinatorFilter)),
    [coordinatorFilter],
  );
  // "Show:" chips (drafts / new requests / estimates sent / approved), shared by table and calendar.
  const [eventTypes, setEventTypes] = useState(() =>
    sanitizeEventTypes(eventTypesRedux),
  );
  const eventTypesKey = useMemo(
    () => JSON.stringify(eventTypesToParams(eventTypes)),
    [eventTypes],
  );
  // Quick view chips (unconfirmed / upcoming N days / ongoing), shared by the three views.
  const [quickView, setQuickView] = useState<QuickView>(null);
  // "Hide duplicates" checkbox (2026-10-05), checked by default: duplicates hidden in the table, calendar and overview.
  const [showDuplicates, setShowDuplicates] = useState(false);
  const [financeControls, setFinanceControls] = useState(defaultFinanceControls);
  const [financeMode, setFinanceMode] = useState("followup");
  const [filterFeedback, setFilterFeedback] = useState("");
  const [isFilterInfoOpen, setIsFilterInfoOpen] = useState(false);
  const filterInfoAnchorRef = useRef<HTMLButtonElement>(null);
  // What the last table fetch asked for (the skip-if-unchanged check below ignores it otherwise).
  const fetchedShowDuplicatesRef = useRef(false);
  const quickViewKey = useMemo(
    () => JSON.stringify({ ...quickViewToParams(quickView), ...duplicatesToParams(showDuplicates) }),
    [quickView, showDuplicates],
  );
  // Highlighted shows (max 5 per person, saved by the API). Staff only.
  const highlights = useHighlights(!isActiveRole(USER_ROLES.CLIENT));

  const [eventInfo, setEventInfo] = useState(null);
  const [tab, setTab] = useState("Dashboard");
  const [showEditNoteModal, setShowEditNoteModal] = React.useState(
    showEditNoteModalInit,
  );
  const [shouldSubmitForm, setShouldSubmitForm] = React.useState(false);
  const [onSubmitUI, setOnSubmitUI] = React.useState({
    isLoading: false,
  });
  const [editEventModal, setEditEventModal] = useState({
    status: false,
    data: null,
  });
  const [deleteEventModal, setDeleteEventModal] = React.useState({
    status: false,
    id: null,
  });
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [contextMenu, setContextMenu] = React.useState({
    status: false,
    mouseY: null,
    mouseX: null,
    row: null,
  });
  const [searchBy, setSearchBy] = React.useState(searchByRedux || []);
  const [hideRowBackgrounds, setHideRowBackgrounds] = React.useState(
    JSON.parse(localStorage.getItem("hideRowBackgrounds")) || false,
  );
  // State variables end...

  // Overview ↔ table ↔ calendar. The overview loads its own data (GET
  // dashboard/board). The calendar shares the display filters (status,
  // coordinators, search) but not sort/pagination/date-range — it loads every
  // event touching the visible month through its own hook.
  const [storedView, setView] = useDashboardView();
  // Clients have no view switch: they always get the table.
  const canViewBilling = isActiveRole(USER_ROLES.SUPERADMIN) ||
    (isActiveRole(USER_ROLES.ADMIN, USER_ROLES.COORDINATOR) && auth?.canViewFinancialDashboard === true);
  const canViewPayroll = isActiveRole(USER_ROLES.SUPERADMIN) || (isActiveRole(USER_ROLES.ADMIN) && auth?.canViewPayrollDashboard === true);
  const canViewFinance = canViewBilling || canViewPayroll;
  const view = isActiveRole(USER_ROLES.CLIENT) ? "table" :
    storedView === "finance" && !canViewFinance ? "overview" : storedView;
  const clientChecklists = useClientChecklists(rows.map(row => row?._id).filter(Boolean), view === "table" && tableColumns.some(column => column.id === "clientOnboarding" && column.visible !== false));
  const [calendarMonth, setCalendarMonth] = useState(() =>
    dayjs().format("YYYY-MM"),
  );
  const calendarRange = useMemo(
    () => monthGridRange(calendarMonth),
    [calendarMonth],
  );
  const calendar = useCalendarEvents(
    {
      rangeStart: calendarRange.start,
      rangeEnd: calendarRange.end,
      searchBy,
      coordinatorFilter,
      eventTypes,
      quickView,
      showDuplicates,
      search: filterParams?.search || "",
    },
    view === "calendar" && tab === "Dashboard",
  );

  // ====== DASHBOARD FILTERS MANAGEMENT ======
  const {
    originalFilters,
    savedFilters,
    isSaving,
    isDeleting,
    isLoading: isLoadingFilters,
    saveFilters,
    loadFilters,
    deleteFilters,
  } = useDashboardFilters("dashboard-events");

  // Get column visibility from Redux
  const { columnVisibility } = useSelector(
    (state) => state.tableColumnVisibility || {},
  );
  const dashboardColumnVisibility = useMemo(
    () => columnVisibility?.["dashboard-events-table"] ?? {}, [columnVisibility],
  );

  const currentDashboardFilters = useMemo(() => JSON.parse(JSON.stringify(extractFiltersFromState({
    filterParams, filterDates, searchBy, coordinatorFilter, eventTypes, quickView,
    rowsPerPage, hiddenColumns: Object.keys(dashboardColumnVisibility).length ? dashboardColumnVisibility
      : originalFilters?.data?.filters?.hiddenColumns ?? initialData.hiddenColumns,
    showDuplicates, finance: financeControls,
  }))), [filterParams, filterDates, searchBy, coordinatorFilter, eventTypes, quickView, rowsPerPage,
    dashboardColumnVisibility, originalFilters?.data?.filters?.hiddenColumns, initialData,
    showDuplicates, financeControls.status, financeControls.archivedOnly]);
  const isFilterDataUpdated = !lodash.isEqual(
    currentDashboardFilters, originalFilters?.data?.filters ?? initialData,
  );

  // Manual save filters handler (called by Save button)
  const handleSaveDashboardFilters = () => {
    const currentFilters = currentDashboardFilters;

    saveFilters(
      "dashboard-events",
      currentFilters,
      () => setFilterFeedback("Dashboard filters saved."),
      (error) => {
        console.error("Error saving dashboard filters:", error);
        setFilterFeedback("Could not save dashboard filters. Please try again.");
      },
    );
  };

  // Function to clear saved filters
  const clearSavedFiltersHandler = () => {
    setIsFilterInfoOpen(false);
    // 1. Define the cleared/default filter values upfront
    const clearedFilterParams = {
      search: "",
      sortOrder: "",
      sortField: "",
    };

    // 2. Reset all local filter state to defaults
    setFilterParams(clearedFilterParams);
    setFilterDates(initialFiltersDates);
    setSearchBy([]);
    setCoordinatorFilter(EMPTY_COORDINATOR_FILTER);
    setEventTypes([...DEFAULT_EVENT_TYPES]);
    setQuickView(null);
    setShowDuplicates(false);
    setFinanceControls(defaultFinanceControls());
    setRowsPerPage(25);
    // Use page 1 (not 0) to match the page-reset effect and avoid a
    // second state-update cycle that would re-trigger the fetch effect
    setPage(1);
    setTableColumns(getColumns());
    if (resetColumnBtnRef.current) {
      resetColumnBtnRef.current?.click();
    }

    // 3. Delete saved filters from backend
    if (originalFilters?.data?.filters) {
      deleteFilters("dashboard-events",
        () => setFilterFeedback("Saved dashboard filters cleared."),
        () => setFilterFeedback("Filters reset locally. Could not clear the saved preferences."));
    } else setFilterFeedback("Dashboard filters cleared.");
    if (view !== "table") return;

    // 4. Immediately dispatch the API call with the cleared values so we
    //    don't rely on the useEffect chain (which could see stale closure
    //    state or skip the call via the hasFiltersChanged guard).
    //    Mark the ref so the consolidated useEffect skips its next fetch.
    skipNextFetchRef.current = true;
    dispatch(
      getDashboardEventsAction({
        params: {
          page: 1,
          limit: 25,
          filters: "",
          subSort: "",
          ...(isActiveRole(USER_ROLES.CLIENT)
            ? {}
            : eventTypesToParams(DEFAULT_EVENT_TYPES)),
          ...clearedFilterParams,
        },
        additionalData: {
          searchString: "",
          searchBy: [],
          rowsPerPage: 25,
          filtersDate: initialFiltersDates,
          coordinatorFilter: EMPTY_COORDINATOR_FILTER,
          eventTypes: [...DEFAULT_EVENT_TYPES],
        },
      }),
    );
  };
  // ====== END DASHBOARD FILTERS MANAGEMENT ======

  // form schema start...
  const formSchema = Yup.array(
    Yup.object().shape({
      eventId: Yup.string().required("eventId is required!"),
      eventGustoStatus: Yup.string().oneOf([
        ...gustoTypes.map((type) => {
          return type.value;
        }),
        "",
      ]),
      eventNotes: Yup.string().max(
        400,
        "Notes should have at most 400 characters!",
      ),
      eventDepositInvoice: Yup.string(),
      eventClientSentPO: Yup.string(),
      isEventClientSentPOBeingEdited: Yup.boolean().required(
        "isEventClientSentPOBeingEdited is required!",
      ),
      isEventDepositInvoiceBeingEdited: Yup.boolean().required(
        "isEventDepositInvoiceBeingEdited is required!",
      ),
    }),
  );

  const formik = useFormik({
    initialValues,
    validationSchema: formSchema,
    onSubmit: (values) => {
      const payload = {
        eventData: [],
      };
      for (let i = 0; i < rows?.length; i++) {
        if (
          !formRowComparatorHandler({
            formRow: rows?.[i],
            originalRow: values?.[i],
          })
        ) {
          payload.eventData.push(values?.[i]);
        }
      }

      dispatch(
        updateEventFromDashboardAction({
          payload,
          beforeCallback: () => {
            setOnSubmitUI((onSubmitUI) => {
              return {
                ...onSubmitUI,
                isLoading: true,
              };
            });
          },
          afterCallback: () => {
            setOnSubmitUI((onSubmitUI) => {
              return {
                ...onSubmitUI,
                isLoading: false,
              };
            });
          },
          successCallback: () => {
            setShouldSubmitForm(false);
            fetchEventsHandler({});
          },
          failureCallback: ({ error }) => {
            dispatch({
              type: ALERT_DIALOG,
              payload: {
                open: true,
                title: "Error!",
                message:
                  error?.response?.data?.message || `Some error occured!`,
              },
            });
          },
        }),
      );
    },
  });

  // useEffect start...
  React.useEffect(() => {
    resetFormValuesHandler();
  }, [rows]);

  // Load filters on component mount
  React.useEffect(() => {
    // Cached table rows do not replace saved preferences, including Finance filters.
    loadFilters(
      "dashboard-events",
      (savedFiltersData) => {
        const { data } = savedFiltersData || {};
        // If there are no filters found in the response, we should mark as initialised
        // so the normal fetch logic can proceed. If there are filters, the
        // savedFilters watcher effect will handle initialisation after applying them.
        if (!data || (Object.keys(data).length === 0 && !data.filters)) {
          setIsFilterInitialised(true);
        }
      },
      (error) => {
        setIsFilterInitialised(true);
      },
    );
  }, []);

  // Consolidated effect for fetching table data
  useEffect(() => {
    // Only proceed if filters have been initialised
    if (!isFilterInitialised) return;
    // The overview and the calendar load their own data; the table read
    // (P&L per event) waits until the table is on screen.
    if (view !== "table") return;

    // If the clear handler already dispatched a fresh fetch, skip this cycle
    if (skipNextFetchRef.current) {
      skipNextFetchRef.current = false;
      return;
    }
    const currentFilters = extractFiltersFromState({
      filterParams,
      filterDates,
      searchBy,
      coordinatorFilter,
      eventTypes,
      quickView,
      showDuplicates,
      finance: financeControls,
      rowsPerPage,
      hiddenColumns: dashboardColumnVisibility,
    });

    const savedData = savedFilters?.data;

    // Skip API call only if:
    // 1. Dashboard already has data, AND
    // 2. Filters are initialized, AND
    // 3. Filters haven't changed, AND
    // 4. Page matches the currentPage in Redux (pagination triggers when page !== currentPage)
    const isPageUnchanged = page === currentPage;

    if (
      !!dashboard.length &&
      isFilterInitialised &&
      !hasFiltersChanged(currentFilters, savedData) &&
      isPageUnchanged &&
      // Duplicate visibility must also match the cached table request.
      fetchedShowDuplicatesRef.current === showDuplicates
    ) {
      return;
    }

    // Use a small debounce to catch multiple state updates at once (e.g. from saved filters)
    const timeout = setTimeout(() => {
      fetchEventsHandler({});
    }, 300);

    return () => {
      clearTimeout(timeout);
    };
  }, [
    isFilterInitialised,
    page,
    rowsPerPage,
    filterParams?.sortField,
    filterParams?.sortOrder,
    filterParams?.search,
    filterDates?.startDate,
    filterDates?.endDate,
    searchBy,
    coordinatorFilterKey,
    eventTypesKey,
    quickViewKey,
    tab,
    view,
  ]);

  // Handle page reset when filters change
  useEffect(() => {
    if (!isFilterInitialised) return;
    if (page !== 1) {
      setPage(1);
    }
  }, [
    rowsPerPage,
    filterParams?.sortField,
    filterParams?.sortOrder,
    filterParams?.search,
    filterDates?.startDate,
    filterDates?.endDate,
    searchBy,
    coordinatorFilterKey,
    eventTypesKey,
    quickViewKey,
    tab,
  ]);

  // submitForm useEffect...
  React.useEffect(() => {
    if (shouldSubmitForm) {
      formik.submitForm();
    }
  }, [shouldSubmitForm]);

  useEffect(() => {
    setRows(dashboard);
  }, [dashboard]);

  useEffect(() => {
    if (state?.create) {
      setTab("CreateEvent");
    }
  }, [state]);

  // The saved record is server-owned. Live drafts are compared directly above;
  // syncing column changes into that record races with preference restoration.

  // ====== DASHBOARD FILTERS USEEFFECT HOOKS ======

  // Watch for changes in savedFilters from Redux store
  React.useEffect(() => {
    const { data } = savedFilters || {};

    if (data && (data?.filters || Object.keys(data).length > 0)) {
      const appliedFilters = applyFiltersToState(data);

      if (appliedFilters) {
        // Apply filter params. A saved sort on a column that is no longer
        // sortable (Show/Status) is dropped instead of applied silently.
        const savedSortField = appliedFilters.filterParams?.sortField;
        const isSavedSortValid = SORTABLE_FIELDS.includes(savedSortField);
        setFilterParams((prev) => ({
          ...prev,
          search: appliedFilters.filterParams?.search ?? "",
          sortOrder: isSavedSortValid
            ? appliedFilters.filterParams?.sortOrder || prev.sortOrder
            : prev.sortOrder,
          sortField: isSavedSortValid ? savedSortField : prev.sortField,
        }));

        // Apply filter dates
        if (
          appliedFilters.filterDates?.startDate ||
          appliedFilters.filterDates?.endDate
        ) {
          setFilterDates(appliedFilters.filterDates);
        }

        // Apply search filters
        setSearchBy(appliedFilters.searchBy ?? []);

        // Apply the coordinator filter
        setCoordinatorFilter(appliedFilters.coordinatorFilter ?? EMPTY_COORDINATOR_FILTER);

        // Apply the "Show:" type chips
        setEventTypes(sanitizeEventTypes(appliedFilters.eventTypes));

        // Apply the quick view chip
        setQuickView(sanitizeQuickView(appliedFilters.quickView));

        setShowDuplicates(appliedFilters.showDuplicates === true);
        setFinanceControls(previous => ({ ...previous, ...appliedFilters.finance }));

        // Apply rows per page
        if (appliedFilters.rowsPerPage) {
          setRowsPerPage(appliedFilters.rowsPerPage);
        }

        // Restore hidden columns if they exist
        if (
          appliedFilters.hiddenColumns &&
          Object.keys(appliedFilters.hiddenColumns).length > 0
        ) {
          dispatch(
            setTableColumnVisibility(
              "dashboard-events-table",
              appliedFilters.hiddenColumns,
            ),
          );
          onColumnVisibilityChange(appliedFilters.hiddenColumns);
        }
      }
      filtersAppliedRef.current = true;
      setIsFilterInitialised(true);
    }
  }, [savedFilters, dispatch]);

  React.useEffect(() => {
    if (filtersAppliedRef.current && !isFilterInitialised) {
      filtersAppliedRef.current = false;
      setIsFilterInitialised(true);
    }
  }, [
    filterParams?.search,
    filterParams?.sortOrder,
    filterParams?.sortField,
    filterDates?.startDate,
    filterDates?.endDate,
    searchBy,
    coordinatorFilterKey,
    eventTypesKey,
    quickViewKey,
    rowsPerPage,
  ]);


  // ====== END DASHBOARD FILTERS USEEFFECT HOOKS ======

  // submitForm useEffect...
  // useEffect end...

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const formRowComparatorHandler = ({ formRow, originalRow }) => {
    const formRowObj = {
      eventId: formRow?._id,
      eventGustoStatus: formRow?.eventGustoStatus,
      eventNotes: formRow?.eventNotes,
      eventDepositInvoice: formRow?.eventDepositInvoice,
      eventClientSentPO: formRow?.eventClientSentPO,
    };

    const originalRowObj = {
      eventId: originalRow?.eventId,
      eventGustoStatus: originalRow?.eventGustoStatus,
      eventNotes: originalRow?.eventNotes,
      eventDepositInvoice: originalRow?.eventDepositInvoice,
      eventClientSentPO: originalRow?.eventClientSentPO,
    };

    return lodash.isEqual(formRowObj, originalRowObj);
  };

  const getShortenedString = ({ string, totalChars }) => {
    return `${string?.substr?.(0, totalChars || 20)}${
      string?.length > (totalChars + 1 || 20) ? "..." : ""
    }`.trim();
  };

  const resetFormValuesHandler = () => {
    formik.setValues((values) => {
      return rows?.map((row) => {
        return {
          eventId: row?._id,
          eventGustoStatus: row?.eventGustoStatus,
          eventNotes: row?.eventNotes || "",
          eventClientSentPO: row?.eventClientSentPO || "",
          eventDepositInvoice: row?.eventDepositInvoice || "",
          isEventClientSentPOBeingEdited: false,
          isEventDepositInvoiceBeingEdited: false,
        };
      });
    });
  };

  function refreshNewEventRequest() {
    fetchEventsHandler({});
  }

  const fetchEventsHandler = ({ params }) => {
    const { status, ...rest } = filterDates;
    dispatch(
      getDashboardEventsAction({
        params: {
          page,
          limit: rowsPerPage,
          filters: searchBy?.map((item) => item?.value)?.join(","),
          subSort: searchBy?.map((item) => item?.subSort)?.join(","),
          ...coordinatorFilterToParams(coordinatorFilter),
          ...(isActiveRole(USER_ROLES.CLIENT) ? {} : eventTypesToParams(eventTypes)),
          ...(isActiveRole(USER_ROLES.CLIENT) ? {} : quickViewToParams(quickView)),
          ...(isActiveRole(USER_ROLES.CLIENT) ? {} : duplicatesToParams((fetchedShowDuplicatesRef.current = showDuplicates))),
          ...(filterParams || {}),
          ...(rest || {}),
          ...(params || {}),
        },
        additionalData: {
          searchString: filterParams?.search,
          searchBy,
          rowsPerPage,
          filtersDate: filterDates,
          coordinatorFilter,
          eventTypes,
          quickView,
        },
      }),
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Sorting is server-side (`sortField`/`sortOrder` go to getAllEvents);
  // changing the params re-triggers the fetch effect. First click = asc.
  const handleSortRequest = (field) => {
    const newOrder =
      filterParams?.sortOrder === "asc" && filterParams?.sortField === field
        ? "desc"
        : "asc";
    setFilterParams((filterParams) => {
      return {
        ...filterParams,
        sortOrder: newOrder,
        sortField: field,
      };
    });
  };

  const handleSearch = (e) => {
    // const searchStr = e.target.value;
    // if (!searchStr || searchStr === "") {
    //   dispatch(fetchNewEventAction({ role: userRole }));
    // } else {
    //   dispatch(searchNewEventsAction({ role: userRole, eventName: searchStr }));
    // }
    const value = e?.target?.value?.replace(inputRegex, "");
    setFilterParams((filterParams) => {
      return {
        ...filterParams,
        search: value,
      };
    });
  };

  // Back arrow of the Create Event tab: asks before discarding the build
  // in progress (steps already completed stay under the draft events).
  const closeCreateEventTabHandler = () => {
    dispatch(
      confirmAndCloseCreateEventAction(() => {
        setTab("Dashboard");
      }),
    );
  };

  const closeEditNoteModalHandler = () => {
    setShowEditNoteModal({ ...showEditNoteModalInit });
  };

  const editNoteSuccessCallback = (payload) => {
    formik.setValues((values) => {
      return values?.map((row) => {
        if (row?.eventId === showEditNoteModal?.eventId) {
          return {
            ...row,
            eventNotes: payload?.eventNotes,
            isEventClientSentPOBeingEdited: false,
            isEventDepositInvoiceBeingEdited: false,
          };
        } else {
          return {
            ...row,
            isEventClientSentPOBeingEdited: false,
            isEventDepositInvoiceBeingEdited: false,
          };
        }
      });
    });
    closeEditNoteModalHandler();
    setShouldSubmitForm(true);
  };

  // Overview → full show page (the board sends coordinators under another name).
  function openBoardShow(show) {
    navigateToPage({ ...show, assignedCoordinatorId: show?.coordinators ?? [] });
  }

  function navigateToPage(row) {
    // Same rule as the email link landing (/show): see _utils/showPage.ts.
    const page = showPageFor(row, {
      clientNotApproved: isActiveRole(USER_ROLES.CLIENT) && !auth?.isApproved,
    });
    navigate(page.path, page.state ? { state: page.state } : undefined);
  }

  const onColumnVisibilityChange = useCallback((updatedColumns) => {
    setTableColumns((prev) => {
      return prev.map((col) => ({
        ...col,
        visible: updatedColumns[col.id],
      }));
    });
  }, []);

  // Syncs tableColumns.visible with Redux when dashboardColumnVisibility
  // changes — covers the case where Redux already had state in memory but
  // the localStorage init in useState didn't capture it (e.g. another tab
  // changed it, savedFilters from the BE arrived later). Without this
  // effect, navigating away and back reinitializes local state ignoring Redux.
  React.useEffect(() => {
    if (!dashboardColumnVisibility) return;
    if (Object.keys(dashboardColumnVisibility).length === 0) return;
    setTableColumns((prev) => {
      let changed = false;
      const next = prev.map((col) => {
        const nextVisible = dashboardColumnVisibility[col.id];
        if (typeof nextVisible !== "boolean") return col;
        if (col.visible === nextVisible) return col;
        changed = true;
        return { ...col, visible: nextVisible };
      });
      return changed ? next : prev;
    });
  }, [dashboardColumnVisibility]);

  const isColumnVisible = useCallback(
    (id) => {
      const col = tableColumns?.find((c) => c.id === id);
      if (!col) return false;
      return typeof col.visible === "boolean"
        ? col.visible
        : col.defaultVisible;
    },
    [tableColumns],
  );

  const isAllColumnsHidden = useCallback(() => {
    return !tableColumns?.some((col) =>
      typeof col.visible === "boolean" ? col.visible : true,
    );
  }, [tableColumns]);

  return (
    <>
      <Snackbar
        open={!!filterFeedback || !!highlights.message}
        autoHideDuration={5000}
        onClose={() => { setFilterFeedback(""); highlights.clearMessage(); }}
        message={filterFeedback || highlights.message}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      />
      {tab === "Dashboard" ? (
        <>
          <Box
            sx={{
              padding: "20px 40px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "12px 24px",
              "@media (max-width: 600px)": {
                flexDirection: "column",
                alignItems: "stretch",
                padding: "20px 20px",
              },
            }}
          >
            <Typography variant={isSmallScreen ? "h3" : "h1"}>
              Dashboard
              <DashboardColorsLegend view={view} />
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.75rem",
                flexShrink: 0,
              }}
            >
              {!isActiveRole(USER_ROLES.CLIENT) ? (
                <DashboardViewToggle value={view} onChange={setView} canViewFinance={canViewFinance} financeLabel={canViewPayroll ? canViewBilling ? "Finance & Payroll" : "Payroll" : "Finance"} />
              ) : null}
              {onSubmitUI?.isLoading ? (
                <CircularProgress
                  size={22}
                  sx={{
                    color: getCssVariableHandler({
                      variableName: "--font-rgb",
                    }),
                  }}
                />
              ) : null}
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                flex: "1 1 490px",
                minWidth: 0,
                "@media (max-width: 600px)": {
                  flex: "none",
                  width: "100%",
                },
                "& .MuiInputBase-root": {
                  background: "rgba(0, 0, 0, 0.01) !important",
                  boxShadow:
                    "0px 0px 30px 0px rgba(209, 117, 182, 0.20) !important",
                  borderRadius: "8px",
                  padding: "5px 24px 5px 7px",
                  "&:before": {
                    content: "none",
                  },
                  "&:after": {
                    content: "none",
                  },
                  "& svg": {
                    color: "#ffffff",
                  },
                  "& input": {
                    color: "#ffffff",
                  },
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  flexWrap: "wrap",
                  gap: "0.75rem",
                  width: "100%",
                  "@media (max-width: 600px)": {
                    justifyContent: "flex-start",
                  },
                  "& .MuiInputBase-root": {
                    background: "rgba(0, 0, 0, 0.01) !important",
                    boxShadow:
                      "0px 0px 30px 0px rgba(209, 117, 182, 0.20) !important",
                    borderRadius: "8px",
                    padding: "5px 20px 5px 7px",
                    "&:before": {
                      content: "none",
                    },
                    "&:after": {
                      content: "none",
                    },
                    "& svg": {
                      color: "#ffffff",
                    },
                    "& input": {
                      color: "#ffffff",
                    },
                  },
                }}
              >
                {/* Date-range filter is a table thing; the calendar navigates by month. */}
                {view === "table" ? (
                <Tooltip
                  open={!!filterDates?.status}
                  PopperProps={{
                    sx: {
                      zIndex: "1200",
                    },
                  }}
                  sx={{}}
                  title={
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <ClickAwayListener
                        onClickAway={() => {
                          setFilterDates((prev) => ({
                            ...prev,
                            status: !prev.status,
                          }));
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "1rem",
                            padding: "0.25rem",
                          }}
                        >
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "0.5rem",
                            }}
                          >
                            <Typography className="no-wrap">
                              Start Date:
                            </Typography>
                            <CustomDatePicker
                              name="startDate"
                              onChange={(date) => {
                                // setFieldValue("eventStart", date?.format("YYYY-MM-DD"));
                                if (!date) return;
                                setFilterDates((searchFilters) => {
                                  return {
                                    ...searchFilters,
                                    startDate: date?.format("YYYY-MM-DD"),
                                  };
                                });
                              }}
                              sx={{
                                "& fieldset": {
                                  paddingLeft: "0.25rem",
                                  paddingRight: "0.25rem",
                                },
                                padding: "0 0.5rem",
                                border: "none !important",
                                height: "2.5rem",
                                width: "14rem !important",
                              }}
                              slotProps={{
                                textField: { placeholder: "Start date" },
                                actionBar: {
                                  actions: ["clear"],
                                },
                              }}
                              defaultValue={dayjs(filterDates?.startDate || "")}
                              // format={
                              //   filterDates?.startDate
                              //     ? "ddd MM/DD/YYYY"
                              //     : "MM/DD/YYYY"
                              // }
                            />
                            {/* <GenericTransparentBtn
                          onClick={() => {
                            setFilterDates(filterDates => {
                              return {
                                ...filterDates,
                                startDate: ""
                              }
                            })
                          }}
                        >
                          <Clear />
                        </GenericTransparentBtn> */}
                          </Box>
                          <Box
                            sx={{
                              width: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "0.5rem",
                            }}
                          >
                            <Typography className={"no-wrap"}>
                              End Date: &nbsp;
                            </Typography>
                            <CustomDatePicker
                              name="endDate"
                              onChange={(date) => {
                                // setFieldValue("eventStart", date?.format("YYYY-MM-DD"));
                                if (!date) return;
                                setFilterDates((searchFilters) => {
                                  return {
                                    ...searchFilters,
                                    endDate: date?.format("YYYY-MM-DD"),
                                  };
                                });
                              }}
                              sx={{
                                "& fieldset": {
                                  paddingLeft: "0.25rem",
                                  paddingRight: "0.25rem",
                                },
                                padding: "0 0.5rem",
                                border: "none !important",
                                height: "2.5rem",
                                width: "14rem !important",
                              }}
                              slotProps={{
                                textField: { placeholder: "End date" },
                                actionBar: {
                                  actions: ["clear"],
                                },
                              }}
                              // value={dayjs(values.eventStart)}
                              defaultValue={dayjs(filterDates?.endDate || "")}
                              // format={
                              //   filterDates?.endDate
                              //     ? "ddd MM/DD/YYYY"
                              //     : "MM/DD/YYYY"
                              // }
                            />
                          </Box>
                          <ClearAllTextButton
                            onClear={() => {
                              setFilterDates(initialFiltersDates);
                            }}
                          />
                        </Box>
                      </ClickAwayListener>
                    </LocalizationProvider>
                  }
                >
                  <IconButton
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid #FFF",
                      background:
                        "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                      boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                      minWidth: "auto",
                      padding: "5px !important",
                      height: "2.25rem",
                      width: "2.25rem",
                    }}
                    onClick={(e) => {
                      setFilterDates((prev) => ({
                        ...prev,
                        status: !prev.status,
                      }));
                    }}
                  >
                    <CalendarMonth
                      sx={{
                        color: "#FFF",
                      }}
                    />
                  </IconButton>
                </Tooltip>
                ) : null}

                {!isActiveRole(USER_ROLES.CLIENT) && (
                  <DashboardFilter
                    hideIncludeArchive
                    filterByOptions={view === "finance" ? [] : filterByOptions}
                    onChange={setSearchBy}
                    value={view === "finance" ? [] : searchBy}
                    // Same state as the Status / Coordinators column headers,
                    // so the three surfaces always agree. One funnel for the
                    // three views (overview, table, calendar).
                    extraTitle={view === "finance" ? "Finance" : "Show"}
                    extraCount={
                      (coordinatorFilter?.selected?.length ?? 0) +
                      (view === "finance"
                        ? Number(!["clients", "payroll"].includes(financeMode) && financeControls.status !== "all") + Number(financeControls.archivedOnly)
                        : Number(!isDefaultEventTypes(eventTypes)))
                    }
                    extraContent={
                      <>
                        {view === "finance" ? (
                          <FinanceToolbarFilters value={financeControls} onChange={setFinanceControls} byClient={financeMode === "clients"} payroll={financeMode === "payroll"} />
                        ) : <EventTypeFilterSection value={eventTypes} onChange={setEventTypes} />}
                        {isUserRole(USER_ROLES.ADMIN, USER_ROLES.SUPERADMIN) ? (
                          <>
                            <Divider
                              sx={{
                                borderColor: getCssVariableHandler({
                                  variableName: "--primary-pink-hex",
                                }),
                              }}
                            />
                            <Typography
                              sx={{
                                fontSize: "0.85rem",
                                fontWeight: 700,
                                px: "1rem",
                                pt: "0.5rem",
                              }}
                            >
                              Coordinators
                            </Typography>
                            <CoordinatorFilterPanel
                              value={coordinatorFilter}
                              onChange={setCoordinatorFilter}
                              autoFocus={false}
                              hideClear
                            />
                          </>
                        ) : null}
                      </>
                    }
                    onClear={() => {
                      if (view === "finance") {
                        setFinanceControls(previous => ({ ...previous, status: "all", archivedOnly: false }));
                        setCoordinatorFilter(EMPTY_COORDINATOR_FILTER);
                        setShowDuplicates(false);
                        setFilterParams(previous => ({ ...previous, search: "" }));
                        return;
                      }
                      setSearchBy([]);
                      setCoordinatorFilter(EMPTY_COORDINATOR_FILTER);
                      setEventTypes([...DEFAULT_EVENT_TYPES]);
                      setQuickView(null);
                    }}
                  />
                )}
                <Box
                  component="form"
                  autoComplete="off"
                  onSubmit={onSubmitFormNoAction}
                  sx={{ flex: "1 1 200px", minWidth: "160px", maxWidth: "270px" }}
                >
                  <Input
                    id="input-with-icon-adornment"
                    inputProps={{ "aria-label": view === "finance" ? "Search finance shows" : "Search dashboard shows" }}
                    value={filterParams?.search || ""}
                    onChange={handleSearch}
                    placeholder="Search here"
                    // startAdornment={
                    //   <InputAdornment position="start">
                    //     <Search />
                    //   </InputAdornment>
                    // }
                    endAdornment={
                      <InputAdornment position="start">
                        {!filterParams?.search ? (
                          <Search
                            sx={{
                              fontSize: "1.25rem",
                              // marginRight: "0.7rem"
                            }}
                          />
                        ) : (
                          <GenericTransparentBtn
                            onClick={() => {
                              setFilterParams((filterParams) => {
                                return {
                                  ...filterParams,
                                  search: "",
                                };
                              });
                            }}
                            style={{
                              background: "grey",
                              padding: "0.10rem",
                              borderRadius: "50%",
                              onHover: {
                                background: "grey",
                                padding: "0.10rem",
                              },
                            }}
                          >
                            <Close
                              sx={{
                                fontSize: "1rem",
                                // marginRight: "0.7rem"
                              }}
                            />
                          </GenericTransparentBtn>
                        )}
                      </InputAdornment>
                    }
                    sx={{
                      paddingLeft: "1rem !important",
                      border: "1px solid #FFF !important",
                      width: "100%",
                    }}
                  />
                </Box>

                <Tooltip title={"Create new event"}>
                  <Button
                    sx={{
                      // marginLeft: "10px",
                      borderRadius: "4px",
                      border: "1px solid #FFF",
                      background:
                        "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                      boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                      minWidth: "auto",
                      padding: "5px !important",
                    }}
                    onClick={(e) => {
                      // dispatch(resetCreateEventSlice());
                      // navigate(`/create-event`);
                      setTab("CreateEvent");
                    }}
                  >
                    <img src={AddPlus} />
                  </Button>
                </Tooltip>

                {/* Save Filters Button */}
                <Tooltip title="Save current filters">
                  <IconButton aria-label="Save dashboard filters"
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid #FFF",
                      background:
                        "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                      boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                      minWidth: "auto",
                      padding: "5px !important",
                      fontSize: "1.5rem",
                    }}
                    onClick={handleSaveDashboardFilters}
                    disabled={isSaving}
                  >
                    {isSaving ? (
                      <CircularProgress
                        size={"1.5rem"}
                        sx={{ color: "white" }}
                      />
                    ) : (
                      <Save fontSize="1.5rem" color="primary" />
                    )}
                  </IconButton>
                </Tooltip>
                {/* Currently Appllied Filters */}
                <Popover
                  open={isFilterInfoOpen}
                  anchorEl={filterInfoAnchorRef.current}
                  onClose={() => setIsFilterInfoOpen(false)}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  PaperProps={{ sx: { mt: 1, p: 1, color: "#fff", backgroundColor: "#000",
                    border: "2px solid #D175B6", borderRadius: "8px", maxWidth: "calc(100vw - 32px)" } }}
                >
                  {view === "finance" ? (
                    <FinanceFilterSummary byClient={financeMode === "clients"} payroll={financeMode === "payroll"} value={financeControls} search={filterParams?.search || ""}
                      coordinators={coordinatorFilter} showDuplicates={showDuplicates}
                      unsaved={isFilterDataUpdated} onClear={clearSavedFiltersHandler} />
                  ) : (
                    <Box
                      sx={{
                        maxWidth: 400,
                        maxHeight: 600,
                        overflowY: "auto",
                        p: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="subtitle1" fontWeight="bold">
                          Currently Applied Filters{" "}
                        </Typography>
                      </Box>
                      {/* un saved filters */}
                      {!!isFilterDataUpdated && (
                        <>
                          <Typography
                            variant="caption"
                            fontWeight="300"
                            color="warning.main"
                            mb={1}
                          >
                            You have unsaved filter changes
                          </Typography>
                        </>
                      )}
                      <Divider color="#8F00FF" sx={{ mb: 1 }} />

                      {/* Status */}
                      <Stack
                        direction="row"
                        alignItems={"center"}
                        flexWrap="wrap"
                        gap={0.5}
                      >
                        <Typography variant="caption" fontWeight="bold">
                          Toggle HR Colors:
                        </Typography>
                        {/* Toggle Row Background Colors */}
                        {isUserRole(
                          USER_ROLES.ADMIN,
                          USER_ROLES.SUPERADMIN,
                        ) && (
                          <Tooltip title={"Toggle HR Colors"}>
                            <Switch
                              checked={!hideRowBackgrounds}
                              onChange={(e) => {
                                setHideRowBackgrounds(!e.target.checked);
                                localStorage.setItem(
                                  "hideRowBackgrounds",
                                  !e.target.checked,
                                );
                              }}
                              sx={{
                                // padding: "0px 0px 0px 0px",
                                "& .MuiSwitch-switchBase": {
                                  color: "#fff",
                                  "&.Mui-checked": {
                                    color: "#F0F",
                                  },
                                  "&.Mui-checked + .MuiSwitch-track": {
                                    backgroundColor: "#F0F",
                                  },
                                },
                                "& .MuiSwitch-track": {
                                  backgroundColor: "rgba(255, 255, 255, 0.5)",
                                },
                                "& .MuiSwitch-input": {
                                  padding: 0,
                                  margin: 0,
                                },
                              }}
                            />
                          </Tooltip>
                        )}
                      </Stack>

                      {/* Status */}
                      <Typography variant="caption" fontWeight="bold">
                        Status
                      </Typography>
                      <Stack direction="row" flexWrap="wrap" gap={0.5} mb={1}>
                        {searchBy?.length ? (
                          searchBy.map((f) => (
                            <Chip
                              color="primary"
                              key={f.value}
                              label={f.label}
                              size="small"
                            />
                          ))
                        ) : (
                          <Chip
                            color="primary"
                            label="None"
                            size="small"
                            variant="outlined"
                          />
                        )}
                      </Stack>

                      {/* Show (type chips) */}
                      <Typography variant="caption" fontWeight="bold">
                        Show
                      </Typography>
                      <Stack direction="row" flexWrap="wrap" gap={0.5} mb={1}>
                        {EVENT_TYPE_OPTIONS.filter((o) =>
                          sanitizeEventTypes(eventTypes).includes(o.value),
                        ).map((o) => (
                          <Chip
                            color="primary"
                            key={o.value}
                            label={o.label}
                            size="small"
                            variant={isDefaultEventTypes(eventTypes) ? "outlined" : "filled"}
                          />
                        ))}
                      </Stack>

                      {/* Coordinators */}
                      <Typography variant="caption" fontWeight="bold">
                        Coordinators
                        {isCoordinatorFilterActive(coordinatorFilter)
                          ? ` (${coordinatorFilter.match === "all" ? "all" : "any"})`
                          : ""}
                      </Typography>
                      <Stack direction="row" flexWrap="wrap" gap={0.5} mb={1}>
                        {isCoordinatorFilterActive(coordinatorFilter) ? (
                          coordinatorFilter.selected.map((c) => (
                            <Chip
                              color="primary"
                              key={c._id}
                              label={coordinatorDisplayName(c)}
                              size="small"
                            />
                          ))
                        ) : (
                          <Chip
                            color="primary"
                            label="None"
                            size="small"
                            variant="outlined"
                          />
                        )}
                      </Stack>

                      {/* Dates */}
                      <Typography variant="caption" fontWeight="bold">
                        Dates
                      </Typography>
                      <Stack spacing={0.25} mb={1}>
                        {filterDates?.startDate || filterDates?.endDate ? (
                          <>
                            {filterDates?.startDate && (
                              <Typography variant="body2">
                                Start:{" "}
                                {dayjs(filterDates.startDate).format(
                                  "MM/DD/YYYY",
                                )}
                              </Typography>
                            )}
                            {filterDates?.endDate && (
                              <Typography variant="body2">
                                End:{" "}
                                {dayjs(filterDates.endDate).format(
                                  "MM/DD/YYYY",
                                )}
                              </Typography>
                            )}
                          </>
                        ) : (
                          <Typography variant="body2">
                            No date filter
                          </Typography>
                        )}
                      </Stack>

                      {/* Search */}
                      <Typography variant="caption" fontWeight="bold">
                        Search
                      </Typography>
                      <Typography variant="body2" mb={1}>
                        {filterParams?.search || "None"}
                      </Typography>

                      {/* Sort */}
                      <Typography variant="caption" fontWeight="bold">
                        Sorted by
                      </Typography>
                      <Typography variant="body2" mb={1}>
                        {view === "calendar"
                          ? "Calendar (by date)"
                          : view === "overview"
                          ? "Overview (by date)"
                          : filterParams?.sortField
                          ? `${
                              tableColumns.find(
                                (c) => c.id === filterParams.sortField,
                              )?.label ?? filterParams.sortField
                            } ${
                              filterParams.sortOrder === "desc"
                                ? "↓ descending"
                                : "↑ ascending"
                            }`
                          : "None (default: Ongoing → Upcoming → Past)"}
                      </Typography>

                      {/* Rows */}
                      <Typography variant="caption" fontWeight="bold">
                        Rows Per Page
                      </Typography>
                      <Typography variant="body2" mb={1}>
                        {rowsPerPage === 10000000000 ? "All" : rowsPerPage}
                      </Typography>

                      {/* Hidden Columns */}
                      <Typography variant="caption" fontWeight="bold">
                        Hidden Columns
                      </Typography>
                      <Stack direction="row" flexWrap="wrap" gap={0.5} mb={1}>
                        {isAllColumnsHidden() ? (
                          <Chip
                            label="All hidden"
                            size="small"
                            color="warning"
                          />
                        ) : (
                          tableColumns
                            .filter((c) => c.visible === false)
                            .map((c) => (
                              <Chip
                                color="primary"
                                key={c.id}
                                label={c.label}
                                size="small"
                              />
                            ))
                        )}
                      </Stack>

                      <Divider color="#8F00FF" sx={{ my: 1 }} />

                      {/* Clear */}
                      <Box display="flex" justifyContent="center">
                        <ClearAllTextButton
                          onClear={clearSavedFiltersHandler}
                        />
                      </Box>
                    </Box>
                  )}
                </Popover>
                  <IconButton ref={filterInfoAnchorRef} aria-label="Applied dashboard filters"
                    aria-expanded={isFilterInfoOpen}
                    onClick={() => setIsFilterInfoOpen(true)}
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid #FFF",
                      background:
                        "linear-gradient(99deg, #F0F 0%, #8F00FF 100.41%) !important",
                      boxShadow: "0px 0px 20px 0px rgba(209, 117, 182, 0.40)",
                      minWidth: "auto",
                      padding: "5px !important",
                      fontSize: "1.5rem",
                    }}
                    disabled={isDeleting}
                  >
                    {isDeleting ? (
                      <CircularProgress
                        size={"1.5rem"}
                        sx={{ color: "white" }}
                      />
                    ) : (
                      <Info fontSize="1.5rem" color="primary" />
                    )}
                  </IconButton>

                {/* <Button
                sx={{
                  // width: "2rem",
                  // height: "1rem",
                }}
                onClick={() => {
                  dispatch({
                    type: ALERT_DIALOG,
                    payload: {
                      open: true,
                      title: `Confirmation!`,
                      message: `Are you sure you want to discard the changes?`,
                      onOk: resetFormValuesHandler
                    }
                  });
                  // setShowMenuItems((showMenuItems) => {
                  //   return {
                  //     ...showMenuItems,
                  //     csvButtons: !showMenuItems?.csvButtons,
                  //   };
                  // });
                }}
              >
                Discard changes
              </Button> */}
                {/* <Button
                sx={{
                  // width: "2rem",
                  // height: "1rem",
                }}
                onClick={() => {
                  formik.submitForm();
                  // setShowMenuItems((showMenuItems) => {
                  //   return {
                  //     ...showMenuItems,
                  //     csvButtons: !showMenuItems?.csvButtons,
                  //   };
                  // });
                }}
                disabled={onSubmitUI?.isLoading}
              >
                {onSubmitUI?.isLoading ? (
                  <CircularProgress size={22} />
                ) : "Save changes"}
              </Button> */}
              </Box>
            </Box>
          </Box>
          {!isActiveRole(USER_ROLES.CLIENT) ? (
            <QuickViewBar
              value={quickView}
              onChange={setQuickView}
              showDuplicates={showDuplicates}
              onShowDuplicatesChange={setShowDuplicates}
              finance={view === "finance" ? { hideStatuses: ["clients", "payroll"].includes(financeMode), status: financeControls.status,
                onChange: status => setFinanceControls(previous => ({ ...previous, status })) } : undefined}
            />
          ) : null}
          {!isActiveRole(USER_ROLES.CLIENT) && (view !== "finance" || canViewBilling) && <BillingFollowupDashboardNotice kind="finalInvoice" />}
          {!isActiveRole(USER_ROLES.CLIENT) && (view !== "finance" || canViewBilling) && <BillingFollowupDashboardNotice />}
          {!isActiveRole(USER_ROLES.CLIENT) && view !== "overview" && <ClientOnboardingDashboardNotice />}
          {view === "finance" && canViewFinance ? (
            <DashboardFinance key={`${auth?.userId}|${auth?.userRole}|${auth?.canViewFinancialDashboard}|${auth?.canManageFinancialCloseout}|${auth?.canViewPayrollDashboard}|${auth?.canManageGusto}`} controls={financeControls} onControlsChange={setFinanceControls} onModeChange={setFinanceMode} canViewBilling={canViewBilling} canViewPayroll={canViewPayroll}
              onOpenPayroll={row => { const page = showPageFor(row); navigate(page.path, { state: { ...page.state, tab: 8 } }); }}
              search={filterParams?.search || ""} coordinatorFilter={coordinatorFilter}
              showDuplicates={showDuplicates} onOpenShow={navigateToPage} onReviewInvoice={row => {
                const page = showPageFor(row);
                navigate(page.path, { state: { ...page.state, tab: 3 } });
              }}
              canViewCloseout={isActiveRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)} />
          ) : view === "overview" ? (
            <DashboardOverview
              onOpenShow={openBoardShow}
              search={filterParams?.search || ""}
              statusFilters={searchBy}
              eventTypes={eventTypes}
              coordinatorFilter={coordinatorFilter}
              quickView={quickView}
              showDuplicates={showDuplicates}
              highlightIds={highlights.ids}
              onToggleHighlight={(show) => highlights.toggle(show._id)}
              highlightVersion={highlights.version}
            />
          ) : view === "calendar" ? (
            <DashboardCalendar
              month={calendarMonth}
              onMonthChange={setCalendarMonth}
              events={calendar.events}
              loading={calendar.loading}
              error={calendar.error}
              onRetry={calendar.refetch}
              onEventClick={navigateToPage}
              highlightIds={highlights.ids}
            />
          ) : (
          <>
          {/* The table stays mounted while data loads (keeps scroll, widths and
              the current rows visible); the overlay is drawn on top of it. */}
          <Box sx={{ position: "relative" }}>
            <LoadingOverlay
              open={isLoading || archiveLoading || dashboard !== rows}
            />
            <Box>
              <TableColumnManager
                tableId="dashboard-events-table"
                showToolbar={FRONTEND_CONFIG.tableToolBar.dashboard}
                columns={tableColumns}
                onColumnVisibilityChange={onColumnVisibilityChange}
                resetColumnBtnRef={resetColumnBtnRef}
                onReset={() => {
                  resetAllWidths();
                  resetColumnOrder();
                }}
              >
                <Box>
                  <ColumnReorderProvider moveColumn={moveColumn}>
                  <TableContainer
                    className="custom-scroll-design"
                    sx={{
                      ...(isSmallScreen
                        ? {
                            minHeight: "calc(100vh - 323px)",
                          }
                        : {
                            height: "88vh",
                          }),
                      overscrollBehavior: "auto",
                    }}
                  >
                    <Table
                      sx={{ minWidth: "1700px" }}
                      aria-label="sticky table"
                      stickyHeader
                    >
                      <TableHead>
                        <TableRow
                          sx={{
                            "& th": {
                              backgroundColor: `${getCssVariableHandler({
                                variableName: "--primary-pink-rgb",
                              })} !important`,
                              padding: defaultHeaderStyles.padding,
                              fontSize: defaultHeaderStyles.fontSize,
                              color: defaultHeaderStyles.color,
                              whiteSpace: defaultHeaderStyles.whiteSpace,
                              "& span": {
                                color: "#ffffff !important",
                                whiteSpace: "nowrap",
                              },
                            },
                          }}
                        >
                        {/* Cells are declared in default order; OrderedCells
                            renders them in the user's saved order (drag a
                            header onto another to move it). */}
                        <OrderedCells order={columnOrder}>
                          {isColumnVisible("eventStatus") ? (
                            <DraggableHeaderCell
                              columnId="eventStatus"
                              ref={eventStatusHeaderRef}
                              sx={{
                                ...getHeaderStyles("eventStatus", widths["eventStatus"]),
                                ...(isStatusFirstColumn
                                  ? getStickyHeaderStyles("eventStatus")
                                  : {}),
                              }}
                            >
                              {isUserRole(
                                USER_ROLES.ADMIN,
                                USER_ROLES.SUPERADMIN,
                              ) ? (
                                <StatusHeaderFilter
                                  label="Status"
                                  filterByOptions={filterByOptions}
                                  value={searchBy}
                                  onChange={setSearchBy}
                                  onClear={() => setSearchBy([])}
                                />
                              ) : (
                                "Status"
                              )}
                              <ResizeHandle
                                onResize={(px) => setWidth("eventStatus", px)}
                                onReset={() => resetWidth("eventStatus")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("eventName") ? (
                            <DraggableHeaderCell
                              columnId="eventName"
                              sx={{
                                ...getHeaderStyles("eventName", widths["eventName"]),
                                ...getStickyHeaderStyles("eventName", {
                                  isEventStatusVisible:
                                    isColumnVisible("eventStatus"),
                                  eventStatusWidth: effectiveEventStatusWidth,
                                }),
                              }}
                            >
                              Show
                              <ResizeHandle
                                onResize={(px) => setWidth("eventName", px)}
                                onReset={() => resetWidth("eventName")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("venueState") ? (
                            <DraggableHeaderCell
                              columnId="venueState"
                              sx={{
                                ...getHeaderStyles("venueState", widths["venueState"]),
                              }}
                            >
                              <SortableHeaderLabel
                                field="venueState"
                                label="State"
                                sortField={filterParams?.sortField}
                                sortOrder={filterParams?.sortOrder}
                                onSort={handleSortRequest}
                              />
                              <ResizeHandle
                                onResize={(px) => setWidth("venueState", px)}
                                onReset={() => resetWidth("venueState")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("venueCity") ? (
                            <DraggableHeaderCell
                              columnId="venueCity"
                              sx={{
                                ...getHeaderStyles("venueCity", widths["venueCity"]),
                              }}
                            >
                              <SortableHeaderLabel
                                field="venueCity"
                                label="City"
                                sortField={filterParams?.sortField}
                                sortOrder={filterParams?.sortOrder}
                                onSort={handleSortRequest}
                              />
                              <ResizeHandle
                                onResize={(px) => setWidth("venueCity", px)}
                                onReset={() => resetWidth("venueCity")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("client") &&
                          !isActiveRole(USER_ROLES.CLIENT) ? (
                            <DraggableHeaderCell
                              columnId="client"
                              sx={{
                                ...getHeaderStyles("client", widths["client"]),
                              }}
                            >
                              Client
                              <ResizeHandle
                                onResize={(px) => setWidth("client", px)}
                                onReset={() => resetWidth("client")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("venue") ? (
                            <DraggableHeaderCell
                              columnId="venue"
                              sx={{
                                ...getHeaderStyles("venue", widths["venue"]),
                              }}
                            >
                              Venue
                              <ResizeHandle
                                onResize={(px) => setWidth("venue", px)}
                                onReset={() => resetWidth("venue")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("sowStatus") &&
                          !isActiveRole(USER_ROLES.CLIENT) ? (
                            <DraggableHeaderCell
                              columnId="sowStatus"
                              sx={{
                                ...getHeaderStyles("sowStatus", widths["sowStatus"]),
                              }}
                            >
                              Event Status
                              <ResizeHandle
                                onResize={(px) => setWidth("sowStatus", px)}
                                onReset={() => resetWidth("sowStatus")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("eventStart") ? (
                            <DraggableHeaderCell
                              columnId="eventStart"
                              sx={{
                                ...getHeaderStyles("eventStart", widths["eventStart"]),
                              }}
                            >
                              <SortableHeaderLabel
                                field="eventStart"
                                label="Start Date"
                                nowrap
                                sortField={filterParams?.sortField}
                                sortOrder={filterParams?.sortOrder}
                                onSort={handleSortRequest}
                              />
                              <ResizeHandle
                                onResize={(px) => setWidth("eventStart", px)}
                                onReset={() => resetWidth("eventStart")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("eventEnd") ? (
                            <DraggableHeaderCell
                              columnId="eventEnd"
                              sx={{
                                ...getHeaderStyles("eventEnd", widths["eventEnd"]),
                              }}
                            >
                              <SortableHeaderLabel
                                field="eventEnd"
                                label="End Date"
                                nowrap
                                sortField={filterParams?.sortField}
                                sortOrder={filterParams?.sortOrder}
                                onSort={handleSortRequest}
                              />
                              <ResizeHandle
                                onResize={(px) => setWidth("eventEnd", px)}
                                onReset={() => resetWidth("eventEnd")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("daysTillStart") ? (
                            <DraggableHeaderCell
                              columnId="daysTillStart"
                              sx={{
                                ...getHeaderStyles("daysTillStart", widths["daysTillStart"]),
                              }}
                            >
                              <SortableHeaderLabel
                                field="daysTillStart"
                                label="Starts In"
                                nowrap
                                sortField={filterParams?.sortField}
                                sortOrder={filterParams?.sortOrder}
                                onSort={handleSortRequest}
                              />
                              <ResizeHandle
                                onResize={(px) => setWidth("daysTillStart", px)}
                                onReset={() => resetWidth("daysTillStart")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("daysTillEnd") ? (
                            <DraggableHeaderCell
                              columnId="daysTillEnd"
                              sx={{
                                ...getHeaderStyles("daysTillEnd", widths["daysTillEnd"]),
                              }}
                            >
                              <SortableHeaderLabel
                                field="daysTillEnd"
                                label="Ends In"
                                nowrap
                                sortField={filterParams?.sortField}
                                sortOrder={filterParams?.sortOrder}
                                onSort={handleSortRequest}
                              />
                              <ResizeHandle
                                onResize={(px) => setWidth("daysTillEnd", px)}
                                onReset={() => resetWidth("daysTillEnd")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("contact") ? (
                            <DraggableHeaderCell
                              columnId="contact"
                              sx={{
                                ...getHeaderStyles("contact", widths["contact"]),
                              }}
                            >
                              Contact
                              <ResizeHandle
                                onResize={(px) => setWidth("contact", px)}
                                onReset={() => resetWidth("contact")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
  
                          {isColumnVisible("clientOnboarding") && !isActiveRole(USER_ROLES.CLIENT) ? (
                            <DraggableHeaderCell columnId="clientOnboarding" sx={getHeaderStyles("clientOnboarding", widths["clientOnboarding"])}>
                              Client onboarding
                              <ResizeHandle onResize={(px) => setWidth("clientOnboarding", px)} onReset={() => resetWidth("clientOnboarding")} />
                            </DraggableHeaderCell>
                          ) : null}

                          {isColumnVisible("coordinators") ? (
                            <DraggableHeaderCell
                              columnId="coordinators"
                              ref={coordinatorsHeaderRef}
                              sx={{
                                ...getHeaderStyles(
                                  "coordinators",
                                  widths["coordinators"],
                                ),
                              }}
                            >
                              {isUserRole(
                                USER_ROLES.ADMIN,
                                USER_ROLES.SUPERADMIN,
                              ) ? (
                                <CoordinatorHeaderFilter
                                  label="Coordinators"
                                  value={coordinatorFilter}
                                  onChange={setCoordinatorFilter}
                                />
                              ) : (
                                "Coordinators"
                              )}
                              <ResizeHandle
                                onResize={(px) => setWidth("coordinators", px)}
                                onReset={() => resetWidth("coordinators")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("notes") ? (
                            <DraggableHeaderCell
                              columnId="notes"
                              sx={{
                                ...getHeaderStyles("notes", widths["notes"]),
                              }}
                            >
                              Notes
                              <ResizeHandle
                                onResize={(px) => setWidth("notes", px)}
                                onReset={() => resetWidth("notes")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("estimate") &&
                            !isActiveRole(USER_ROLES.COORDINATOR) && (
                              <DraggableHeaderCell
                                columnId="estimate"
                                sx={{
                                  ...getHeaderStyles("estimate", widths["estimate"]),
                                }}
                              >
                                Estimate
                                <ResizeHandle
                                  onResize={(px) => setWidth("estimate", px)}
                                  onReset={() => resetWidth("estimate")}
                                />
                              </DraggableHeaderCell>
                            )}
                          {isColumnVisible("clientPo") ? (
                            <DraggableHeaderCell
                              columnId="clientPo"
                              sx={{
                                ...getHeaderStyles("clientPo", widths["clientPo"]),
                              }}
                            >
                              Client's PO#
                              <ResizeHandle
                                onResize={(px) => setWidth("clientPo", px)}
                                onReset={() => resetWidth("clientPo")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {isColumnVisible("clientDepositInvoice") &&
                            !isActiveRole(USER_ROLES.COORDINATOR) && (
                              <DraggableHeaderCell
                                columnId="clientDepositInvoice"
                                sx={{
                                  ...getHeaderStyles("clientDepositInvoice", widths["clientDepositInvoice"]),
                                }}
                              >
                                Client's Deposit Invoice
                                <ResizeHandle
                                  onResize={(px) => setWidth("clientDepositInvoice", px)}
                                  onReset={() => resetWidth("clientDepositInvoice")}
                                />
                              </DraggableHeaderCell>
                            )}
                          {isColumnVisible("clientFinalInvoice") &&
                            !isActiveRole(USER_ROLES.COORDINATOR) && (
                              <DraggableHeaderCell
                                columnId="clientFinalInvoice"
                                sx={{
                                  ...getHeaderStyles("clientFinalInvoice", widths["clientFinalInvoice"]),
                                }}
                              >
                                Client's Final Invoice
                                <ResizeHandle
                                  onResize={(px) => setWidth("clientFinalInvoice", px)}
                                  onReset={() => resetWidth("clientFinalInvoice")}
                                />
                              </DraggableHeaderCell>
                            )}
                          {isColumnVisible("pl") &&
                          !isUserRole(
                            USER_ROLES.CLIENT,
                            USER_ROLES.COORDINATOR,
                          ) ? (
                            <DraggableHeaderCell
                              columnId="pl"
                              sx={{
                                ...getHeaderStyles("pl", widths["pl"]),
                              }}
                            >
                              P&L
                              <ResizeHandle
                                onResize={(px) => setWidth("pl", px)}
                                onReset={() => resetWidth("pl")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                          {/* <StyledTableCell
                          // colSpan={1}
                          sx={{
                            minWidth: "10rem",
                          }}
                        >
                          Commision
                        </StyledTableCell> */}
                          {/* <StyledTableCell
                          // colSpan={1}
                          sx={{
                            minWidth: "10rem",
                          }}
                        >
                          WB Closed
                        </StyledTableCell> */}
                          {isColumnVisible("invoicedAmount") &&
                          !isUserRole(
                            USER_ROLES.CLIENT,
                            USER_ROLES.COORDINATOR,
                          ) ? (
                            <DraggableHeaderCell
                              columnId="invoicedAmount"
                              sx={{
                                ...getHeaderStyles("invoicedAmount", widths["invoicedAmount"]),
                              }}
                            >
                              Invoiced Amount
                              <ResizeHandle
                                onResize={(px) => setWidth("invoicedAmount", px)}
                                onReset={() => resetWidth("invoicedAmount")}
                              />
                            </DraggableHeaderCell>
                          ) : null}
                        </OrderedCells>
                        </TableRow>
                      </TableHead>
                      <TableBody
                        sx={{
                          "& td": {
                            borderColor: tableRowConfig.borderColor,
                            color: "#ffffff",
                            "& td": {},
                          },
                        }}
                      >
                        {rows?.length === formik?.values?.length &&
                          rows?.map((row, index) => (
                            <StyledTableRow
                              key={index}
                              hidebackground={hideRowBackgrounds}
                              data-cancelled={isCancelledEvent(row) ? "true" : undefined}
                              sx={{
                                backgroundColor: `${getRowBackground(index)} !important`,
                                // Highlighted show: ShowPhaze neon frame around the row.
                                ...(highlights.ids.has(row?._id)
                                  ? {
                                      "& > td": {
                                        borderTop: `${NEON.border} !important`,
                                        borderBottom: `${NEON.border} !important`,
                                      },
                                      "& > td:first-of-type": { borderLeft: `${NEON.border} !important` },
                                      "& > td:last-of-type": { borderRight: `${NEON.border} !important` },
                                    }
                                  : {}),
                                // ...(row?.isEventEditedByClient
                                //   ? {
                                //       backgroundColor: getCssVariableHandler({
                                //         variableName: "--primary-yellow-hex",
                                //       }),
                                //     }
                                //   : {}),
                                // borderBottom: `1px solid white !important`
                              }}
                            >
                            <OrderedCells order={columnOrder}>
                              {isColumnVisible("eventStatus") ? (
                                <StyledTableCell
                                  data-column="eventStatus"
                                  sx={{
                                    ...getBodyStyles("eventStatus", widths["eventStatus"]),
                                    ...(isStatusFirstColumn
                                      ? getStickyBodyStyles("eventStatus", index)
                                      : {}),
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "12px",
                                    }}
                                  >
                                    {(() => {
                                      if (
                                        !isUserRole(
                                          USER_ROLES.SUPERADMIN,
                                          USER_ROLES.ADMIN,
                                        )
                                      )
                                        return null;
                                      const strips = getRowStrips(row);
                                      if (strips.length === 0) return null;
                                      return (
                                        <Box
                                          sx={{
                                            flexShrink: 0,
                                            display: "flex",
                                            width: "100px",
                                            height: "28px",
                                            borderRadius: "4px",
                                            overflow: "hidden",
                                          }}
                                        >
                                          {strips.map((s, i) => (
                                            <Tooltip
                                              key={i}
                                              title={s.reason}
                                              arrow
                                              placement="top"
                                            >
                                              <Box
                                                sx={{
                                                  flex: 1,
                                                  height: "100%",
                                                  backgroundColor: s.color,
                                                  cursor: "default",
                                                }}
                                              />
                                            </Tooltip>
                                          ))}
                                        </Box>
                                      );
                                    })()}
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "2px",
                                      }}
                                    >
                                      <Typography>
                                        {eventStatusLabel(row)}
                                      </Typography>
                                      <EventTypeBadge lifecycle={row?.lifecycle} />
                                    </Box>
                                  </Box>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("eventName") ? (
                                <StyledTableCell
                                  data-column="eventName"
                                  sx={{
                                    ...getBodyStyles("eventName", widths["eventName"]),
                                    ...getStickyBodyStyles("eventName", index, {
                                      isEventStatusVisible:
                                        isColumnVisible("eventStatus"),
                                      eventStatusWidth:
                                        effectiveEventStatusWidth,
                                    }),
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      position: "relative",
                                      cursor: "pointer",
                                      display: "flex",
                                      // justifyContent: "center",
                                      alignItems: "center",
                                      // textWrap: "nowrap",
                                      // wordBreak: "break-all",
                                      "& a": {
                                        lineHeight: "0",
                                      },
                                      "& img": {
                                        marginRight: "10px",
                                      },
                                    }}
                                    onClick={() => {
                                      navigateToPage(row);
                                    }}
                                    onContextMenu={(event) => {
                                      handleEventContextMenu({
                                        event,
                                        row,
                                        setContextMenu,
                                      });
                                    }}
                                  >
                                    {!isActiveRole(USER_ROLES.CLIENT) ? (
                                      <HighlightStar
                                        on={highlights.ids.has(row?._id)}
                                        showName={row?.eventName || "this show"}
                                        onToggle={() => highlights.toggle(row?._id)}
                                        size={18}
                                      />
                                    ) : null}
                                    <Link
                                      // Same rule as the row click (_utils/showPage.ts): an approved show
                                      // opens its details even when no estimate was ever generated.
                                      to={showPageFor(row, { clientNotApproved: isActiveRole(USER_ROLES.CLIENT) && !auth?.isApproved }).path}
                                      state={showPageFor(row, { clientNotApproved: isActiveRole(USER_ROLES.CLIENT) && !auth?.isApproved }).state}
                                    >
                                      <img src={Show} />
                                    </Link>
                                    <Tooltip title={row?.eventName}>
                                      <Box
                                        component="span"
                                        sx={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          flex: 1,
                                          minWidth: 0,
                                          // Duplicate (2026-10-05): kept as a record, struck through.
                                          ...(row?.isDuplicate
                                            ? { textDecoration: "line-through", opacity: 0.6 }
                                            : {}),
                                        }}
                                      >
                                        {row?.eventName}
                                      </Box>
                                    </Tooltip>
                                    {row?.isDuplicate ? (
                                      <Tooltip
                                        arrow
                                        title={duplicateMarkedLabel(
                                          row?.markedDuplicateBy?.name,
                                          row?.markedDuplicateAt,
                                        )}
                                      >
                                      <Box
                                        component="span"
                                        sx={{
                                          flexShrink: 0,
                                          ml: 1,
                                          px: 0.75,
                                          py: 0.25,
                                          borderRadius: "4px",
                                          fontSize: "0.7rem",
                                          fontWeight: 600,
                                          letterSpacing: "0.04em",
                                          border: "1px solid currentColor",
                                          opacity: 0.8,
                                        }}
                                      >
                                        DUPLICATE
                                      </Box>
                                      </Tooltip>
                                    ) : null}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("venueState") ? (
                                <StyledTableCell
                                  data-column="venueState"
                                  sx={{
                                    ...getBodyStyles("venueState", widths["venueState"]),
                                  }}
                                >
                                  <Typography>
                                    {states.getStateCodeByStateName(
                                      row?.venueState,
                                    ) || row?.venueState}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("venueCity") ? (
                                <StyledTableCell
                                  data-column="venueCity"
                                  sx={{
                                    ...getBodyStyles("venueCity", widths["venueCity"]),
                                  }}
                                >
                                  <Typography>{row?.venueCity}</Typography>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("client") &&
                              !isActiveRole(USER_ROLES.CLIENT) ? (
                                <StyledTableCell
                                  data-column="client"
                                  sx={{
                                    ...getBodyStyles("client", widths["client"]),
                                  }}
                                >
                                  {/* <Typography> */}
                                  {/*   <Tooltip */}
                                  {/*     title={`${row?.userId?.firstName || ""} ${row?.userId?.lastName || ""}`} */}
                                  {/*   > */}
                                  {/*     {getShortenedString({ */}
                                  {/*       string: `${row?.userId?.firstName || ""} ${row?.userId?.lastName || ""}`, */}
                                  {/*       totalChars: 15, */}
                                  {/*     })} */}
                                  {/*   </Tooltip> */}
                                  {/* </Typography> */}
                                  <ClientTool data={row?.userId}>
                                    {getShortenedString({
                                      string:
                                        row?.userId?.companyName ||
                                        `${row?.userId?.firstName || ""} ${
                                          row?.userId?.lastName || ""
                                        }`,
                                      totalChars: 15,
                                    })}
                                  </ClientTool>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("venue") ? (
                                <StyledTableCell
                                  data-column="venue"
                                  sx={{
                                    ...getBodyStyles("venue", widths["venue"]),
                                  }}
                                >
                                  <Typography
                                    noWrap
                                    sx={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <Tooltip
                                      title={`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                                    >
                                      <span>
                                        {`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                                      </span>
                                    </Tooltip>
                                    {/* <LineClamp
                                text={`${row?.venue}, ${row?.venueAddressLine1}, ${row?.venueCity}, ${row?.venueState}, ${row?.venueZipCode}`}
                                maxLines={1}
                              /> */}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("sowStatus") &&
                              !isActiveRole(USER_ROLES.CLIENT) ? (
                                <StyledTableCell
                                  data-column="sowStatus"
                                  sx={{
                                    ...getBodyStyles("sowStatus", widths["sowStatus"]),
                                  }}
                                >
                                  {row?.sowStatus || "N/A"}
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("eventStart") ? (
                                <StyledTableCell
                                  data-column="eventStart"
                                  sx={{
                                    ...getBodyStyles("eventStart", widths["eventStart"]),
                                  }}
                                >
                                  <Typography sx={{}}>
                                    {/* {convertDate(row?.eventStart)} */}
                                    {row?.eventStart?.includes?.("/")
                                      ? convertDate(row?.eventStart)
                                      : getUniversalDateTimeFormat({
                                          dateTime: row?.eventStart,
                                        })}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("eventEnd") ? (
                                <StyledTableCell
                                  data-column="eventEnd"
                                  sx={{
                                    ...getBodyStyles("eventEnd", widths["eventEnd"]),
                                  }}
                                >
                                  <Typography>
                                    {/* {convertDate(row?.eventEnd)} */}
                                    {row?.eventEnd?.includes?.("/")
                                      ? convertDate(row?.eventEnd)
                                      : getUniversalDateTimeFormat({
                                          dateTime: row?.eventEnd,
                                        })}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("daysTillStart") ? (
                                <StyledTableCell
                                  data-column="daysTillStart"
                                  sx={{
                                    ...getBodyStyles("daysTillStart", widths["daysTillStart"]),
                                  }}
                                >
                                  <Typography>
                                    {row?.daysTillStart}{" "}
                                    {Math.abs(row?.daysTillStart) == 1
                                      ? "day"
                                      : "days"}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("daysTillEnd") ? (
                                <StyledTableCell
                                  data-column="daysTillEnd"
                                  sx={{
                                    ...getBodyStyles("daysTillEnd", widths["daysTillEnd"]),
                                  }}
                                >
                                  <Typography>
                                    {row?.daysTillEnd}{" "}
                                    {Math.abs(row?.daysTillEnd) == 1
                                      ? "day"
                                      : "days"}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("contact") ? (
                                <StyledTableCell
                                  data-column="contact"
                                  sx={{
                                    ...getBodyStyles("contact", widths["contact"]),
                                  }}
                                >
                                  <Typography>
                                    <Tooltip
                                      title={`${
                                        row?.contactInformationId?.firstName ||
                                        ""
                                      } ${
                                        row?.contactInformationId?.lastName ||
                                        ""
                                      }`}
                                    >
                                      <span>
                                        {getShortenedString({
                                          string: `${
                                            row?.contactInformationId
                                              ?.firstName || ""
                                          } ${
                                            row?.contactInformationId
                                              ?.lastName || ""
                                          }`,
                                          totalChars: 15,
                                        })}
                                      </span>
                                    </Tooltip>
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
  
                              {isColumnVisible("clientOnboarding") && !isActiveRole(USER_ROLES.CLIENT) ? (
                                <StyledTableCell data-column="clientOnboarding" sx={getBodyStyles("clientOnboarding", widths["clientOnboarding"])}>
                                  <ClientChecklistCell state={clientChecklists.get(row?._id)} onRefresh={clientChecklists.refresh} />
                                </StyledTableCell>
                              ) : null}

                              {isColumnVisible("coordinators") ? (
                                <StyledTableCell
                                  data-column="coordinators"
                                  sx={{
                                    ...getBodyStyles(
                                      "coordinators",
                                      widths["coordinators"],
                                    ),
                                  }}
                                >
                                  <CoordinatorAvatars
                                    coordinators={
                                      Array.isArray(row?.assignedCoordinatorId)
                                        ? row.assignedCoordinatorId
                                        : []
                                    }
                                    slots={coordinatorSlots}
                                  />
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("notes") ? (
                                <StyledTableCell
                                  data-column="notes"
                                  sx={{
                                    ...getBodyStyles("notes", widths["notes"]),
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "0.40rem",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        wordBreak: "break-all",
                                        textWrap: "nowrap",
                                      }}
                                    >
                                      <Tooltip
                                        title={
                                          formik?.values?.[index]?.eventNotes
                                        }
                                      >
                                        <span>
                                          {getShortenedString({
                                            string:
                                              formik?.values?.[index]
                                                ?.eventNotes || "N/A",
                                            totalChars: 17,
                                          })}
                                        </span>
                                      </Tooltip>
                                    </Typography>
                                    <Box
                                      sx={{
                                        width: "fit-content",
                                      }}
                                    >
                                      <GenericTransparentBtn
                                        onClick={() => {
                                          setShowEditNoteModal(
                                            (showEditNoteModal) => {
                                              return {
                                                ...showEditNoteModal,
                                                show: true,
                                                eventId: row?._id,
                                                content:
                                                  formik?.values?.[index]
                                                    ?.eventNotes,
                                              };
                                            },
                                          );
                                        }}
                                      >
                                        <Edit />
                                      </GenericTransparentBtn>
                                      {/* <UnderlineButton
                                  title={"Edit"}
                                  onClick={() => {
                                    setShowEditNoteModal(showEditNoteModal => {
                                      return {
                                        ...showEditNoteModal,
                                        show: true,
                                        eventId: row?._id,
                                        content: formik?.values?.[index]?.eventNotes
                                      }
                                    });
                                  }}
                                  styles={{
                                    // alignSelf: "center",
                                    padding: "0",
                                    // width: "100%",
                                    minWidth: "0"
                                  }}
                                /> */}
                                    </Box>
                                  </Box>
                                  {/* <StyledSelect
                              variant="standard"
                              id="demo-simple-select"
                              defaultValue={noteTypes?.[0]}
                              value={
                                row?.commisionType || noteTypes?.[0]?.value
                              }
                              displayEmpty
                              label="note-type"
                              sx={{
                                width: "9rem",
                                height: "36px !important",
                                "& .MuiSelect-select": {
                                  textAlign: "center",
                                },
                              }}
                              renderValue={(selected) => {
                                if (!selected) {
                                  return (
                                    <em style={{ color: "#fff5" }}>
                                      Select Option
                                    </em>
                                  );
                                }
                                return `${selected}`;
                              }}
                              onChange={(e) => {
                                // dispatch({
                                //   type: ALERT_DIALOG,
                                //   payload: {
                                //     open: true,
                                //     title: "Confirmation!",
                                //     message: `Are you sure you want to assign type "${e?.target?.value}" to "${row?.firstName} ${row?.lastName || ""}"?`,
                                //     onOk: () => {
                                //       dispatch(
                                //         toggleContractorTypeAction({
                                //           params: {
                                //             id: row?._id,
                                //           },
                                //           payload: {
                                //             value: e?.target?.value,
                                //           },
                                //           successCallback: () => {
                                //             dispatch({
                                //               type: ALERT_DIALOG,
                                //               payload: {
                                //                 open: true,
                                //                 title: "Success!",
                                //                 message:
                                //                   "Contractor type updated successfully!",
                                //               },
                                //             });
  
                                //             fetchPaginationDataHandler(
                                //               {},
                                //             );
                                //           },
                                //           failureCallback: ({
                                //             error,
                                //           }) => {
                                //             dispatch({
                                //               type: ALERT_DIALOG,
                                //               payload: {
                                //                 open: true,
                                //                 title: "Failure!",
                                //                 message:
                                //                   error?.response?.data
                                //                     ?.message ||
                                //                   "Some error occured!",
                                //               },
                                //             });
                                //           },
                                //         }),
                                //       );
                                //     },
                                //   },
                                // });
                              }}
                              className="custom-scroll-design"
                              inputProps={{
                                MenuProps: {
                                  MenuListProps: {
                                    sx: {
                                      backgroudColor: "white !important",
                                    },
                                    classes: {
                                      paper: "custom-scroll-design",
                                    },
                                  },
                                },
                              }}
                            >
                              <MenuItem disabled>Select Option</MenuItem>
                              {noteTypes
                                ?.map((item) => {
                                  return (
                                    <MenuItem key={item?.value} value={item?.value}>
                                      {item?.label}
                                    </MenuItem>
                                  );
                                })}
                            </StyledSelect> */}
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("estimate") &&
                                !isActiveRole(USER_ROLES.COORDINATOR) && (
                                  <StyledTableCell
                                    data-column="estimate"
                                    sx={{
                                      ...getBodyStyles("estimate", widths["estimate"]),
                                    }}
                                    onClick={async () => {
                                      if (!row?.submittedEstimate?._id) return;
                                      const url = await buildShareableUrl({
                                        baseUrl: `${window?.location?.origin}/shareable/estimate`,
                                        scope: "estimate-page",
                                        eventId: row?._id,
                                        extraParams: {
                                          configurationId:
                                            row?.submittedEstimate?.configurationId,
                                        },
                                      });
                                      window.open(url, "_blank");
                                    }}
                                  >
                                    <Tooltip
                                      title={
                                        row?.submittedEstimate?._id
                                          ? row?.submittedEstimate
                                              ?.estimateNumber || "N/A"
                                          : "N/A"
                                      }
                                    >
                                      <span>
                                        {row?.submittedEstimate?._id
                                          ? getShortenedString({
                                              string:
                                                row?.submittedEstimate
                                                  ?.estimateNumber || "N/A",
                                              totalChars: 15,
                                            }) || "N/A"
                                          : "N/A"}
                                      </span>
                                    </Tooltip>
                                  </StyledTableCell>
                                )}
                              {isColumnVisible("clientPo") ? (
                                <StyledTableCell
                                  data-column="clientPo"
                                  sx={{
                                    ...getBodyStyles("clientPo", widths["clientPo"]),
                                  }}
                                >
                                  {!formik.values?.find(
                                    (value) => value?.eventId === row?._id,
                                  )?.isEventClientSentPOBeingEdited ? (
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "0.5rem",
                                      }}
                                    >
                                      <Typography>
                                        {row?.eventClientSentPO || "N/A"}
                                      </Typography>
                                      <GenericTransparentBtn
                                        onClick={() => {
                                          formik.setValues((values) => {
                                            return values?.map((value) => {
                                              if (value?.eventId === row?._id) {
                                                return {
                                                  ...value,
                                                  isEventClientSentPOBeingEdited: true,
                                                };
                                              } else {
                                                return value;
                                              }
                                            });
                                          });
                                        }}
                                      >
                                        <Edit />
                                      </GenericTransparentBtn>
                                    </Box>
                                  ) : (
                                    <CustomInput
                                      sx={{
                                        maxHeight: "2.5rem",
                                      }}
                                      fullWidth
                                      placeholder="Event PO"
                                      name={`[${index}].eventClientSentPO`}
                                      onChange={formik.handleChange}
                                      // onBlur={handleBlur}
                                      value={
                                        formik.values?.[index]
                                          ?.eventClientSentPO
                                      }
                                      endAdornment={
                                        formik.values?.[index]
                                          ?.eventClientSentPO ? (
                                          <GenericTransparentBtn
                                            onClick={() => {
                                              setShouldSubmitForm(true);
                                            }}
                                          >
                                            <Check
                                              sx={{
                                                opacity: "0.75",
                                              }}
                                            />
                                          </GenericTransparentBtn>
                                        ) : null
                                      }
                                      // readOnly={isViewing}
                                    />
                                  )}
  
                                  {/* <Typography
                            >
                              PHSBR-0125725
                            </Typography> */}
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("clientDepositInvoice") &&
                                !isActiveRole(USER_ROLES.COORDINATOR) && (
                                  <StyledTableCell
                                    data-column="clientDepositInvoice"
                                    sx={{
                                      ...getBodyStyles("clientDepositInvoice", widths["clientDepositInvoice"]),
                                    }}
                                    onClick={async () => {
                                      if (!row?.depositInvoice?._id) return;
                                      const url = await buildShareableUrl({
                                        baseUrl: `${window?.location?.origin}/shareable/depositInvoice`,
                                        scope: "deposit-invoice-page",
                                        eventId: row?._id,
                                        extraParams: {
                                          configurationId:
                                            row?.depositInvoice?.configurationId,
                                        },
                                      });
                                      window.open(url, "_blank");
                                    }}
                                  >
                                    <Tooltip
                                      title={
                                        row?.depositInvoice?._id
                                          ? row?.depositInvoice
                                              ?.depositInvoiceNumber
                                          : "N/A"
                                      }
                                    >
                                      <span>
                                        {row?.depositInvoice?._id
                                          ? getShortenedString({
                                              string:
                                                row?.depositInvoice
                                                  ?.depositInvoiceNumber,
                                              totalChars: 15,
                                            })
                                          : "N/A"}
                                      </span>
                                    </Tooltip>
                                  </StyledTableCell>
                                )}
                              {isColumnVisible("clientFinalInvoice") &&
                                !isActiveRole(USER_ROLES.COORDINATOR) && (
                                  <StyledTableCell
                                    data-column="clientFinalInvoice"
                                    sx={{
                                      ...getBodyStyles("clientFinalInvoice", widths["clientFinalInvoice"]),
                                    }}
                                    onClick={async () => {
                                      if (!row?.finalInvoice?.invoiceId) return;
                                      const url = await buildShareableUrl({
                                        baseUrl: `${window?.location?.origin}/shareable/invoice`,
                                        scope: "invoice-page",
                                        eventId: row?._id,
                                        extraParams: {
                                          configurationId:
                                            row?.finalInvoice?.configurationId,
                                        },
                                      });
                                      window.open(url, "_blank");
                                    }}
                                  >
                                    <Tooltip
                                      title={
                                        row?.finalInvoice?.invoiceId
                                          ? row?.finalInvoice?.invoiceNumber
                                          : "N/A"
                                      }
                                    >
                                      <span>
                                        {row?.finalInvoice?.invoiceId
                                          ? getShortenedString({
                                              string:
                                                row?.finalInvoice
                                                  ?.invoiceNumber,
                                              totalChars: 15,
                                            })
                                          : "N/A"}
                                      </span>
                                    </Tooltip>
                                  </StyledTableCell>
                                )}
                              {isColumnVisible("pl") &&
                              !isUserRole(
                                USER_ROLES.CLIENT,
                                USER_ROLES.COORDINATOR,
                              ) ? (
                                <StyledTableCell
                                  data-column="pl"
                                  sx={{
                                    ...getBodyStyles("pl", widths["pl"]),
                                  }}
                                >
                                  <Typography>
                                    <Tooltip
                                      title={
                                        <Box
                                          sx={{
                                            maxHeight: "500px",
                                            overflowY: "auto",
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "0.25rem",
                                            backgroundColor: "#121524",
                                          }}
                                        >
                                          <Box>
                                            {typeof row?.invoiceAmount ===
                                            "number" ? (
                                              <Typography
                                                sx={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                {`Invoice Amount: $ ${row?.invoiceAmount}`}
                                              </Typography>
                                            ) : null}
                                            {typeof row?.TotalPOs ===
                                            "number" ? (
                                              <Typography
                                                sx={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                {`Positions Payout: $ ${row?.TotalPOs}`}
                                              </Typography>
                                            ) : null}
                                            {typeof row?.Business_Expense ===
                                            "number" ? (
                                              <Typography
                                                sx={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                {`Business Expense: $ ${parseFloat(
                                                  row?.Business_Expense,
                                                )?.toFixed(2)}`}
                                              </Typography>
                                            ) : null}
  
                                            {typeof row?.PLAmount ===
                                            "number" ? (
                                              <Typography
                                                sx={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                {`P&L Amount:`}{" "}
                                                <Typography
                                                  sx={{
                                                    display: "inline-flex",
                                                    color:
                                                      parseFloat(
                                                        row?.PLAmount,
                                                      ).toFixed(2) == 0.0
                                                        ? "white !important"
                                                        : parseFloat(
                                                              row?.PLAmount,
                                                            ) > 0
                                                          ? "#25ff1f !important"
                                                          : "#fc4848 !important",
                                                  }}
                                                >
                                                  ${" "}
                                                  {parseFloat(
                                                    row?.PLAmount,
                                                  )?.toFixed(2)}
                                                </Typography>
                                              </Typography>
                                            ) : null}
                                            {/* {typeof row?.Profit === "number" ? ( */}
                                            {/*   <Typography */}
                                            {/*     sx={{ */}
                                            {/*       textAlign: "right", */}
                                            {/*     }} */}
                                            {/*   > */}
                                            {/*     {`Profit: $ ${row?.Profit}`} */}
                                            {/*   </Typography> */}
                                            {/* ) : null} */}
                                          </Box>
                                        </Box>
                                      }
                                    >
                                      {/* <Typography
                                  className="text-center"
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                >
                                  {row?.contractorCount}
                                </Typography> */}
                                      {parseFloat(row?.PL).toFixed(2) >= 0
                                        ? `${row?.PL}`
                                        : "N/A"}
                                    </Tooltip>
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {isColumnVisible("invoicedAmount") &&
                              !isUserRole(
                                USER_ROLES.CLIENT,
                                USER_ROLES.COORDINATOR,
                              ) ? (
                                <StyledTableCell
                                  data-column="invoicedAmount"
                                  // colSpan={1}
                                  sx={{
                                    ...getBodyStyles("invoicedAmount", widths["invoicedAmount"]),
                                    paddingTop: "0.5rem !important",
                                    paddingBottom: "0.5rem !important",
                                  }}
                                >
                                  <Typography>
                                    {typeof row?.invoiceAmount === "number"
                                      ? `$ ${row?.invoiceAmount}`
                                      : "N/A"}
                                  </Typography>
                                </StyledTableCell>
                              ) : null}
                              {/* <StyledTableCell
                          // colSpan={1}
                            sx={{
                              textAlign: "center",
                              paddingTop: "0.5rem !important",
                              paddingBottom: "0.5rem !important",
                            }}
                          >
                            <Typography
                            >
                            </Typography>
                          </StyledTableCell> */}
                              {/* <StyledTableCell
                          // colSpan={1}
                            sx={{
                              textAlign: "center",
                              paddingTop: "0.5rem !important",
                              paddingBottom: "0.5rem !important",
                            }}
                          >
                            <Typography
                            >
                            </Typography>
                          </StyledTableCell> */}
                            </OrderedCells>
                            </StyledTableRow>
                          ))}
                        {isAllColumnsHidden() && (
                          <TableRow style={{ backgroundColor: "#FFFFFF1A" }}>
                            <TableCell colSpan={2}>
                              <Typography
                                style={{
                                  fontWeight: "600",
                                  color: "#fff",
                                  textAlign: "center",
                                  fontSize: "1.5rem",
                                  padding: "1rem 0",
                                }}
                              >
                                All Columns are Hidden
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  </ColumnReorderProvider>
                  <Box
                    sx={{
                      "& td": {
                        display: "block",
                      },
                      position: "relative",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "black",
                      borderRadius: "0px 0px 15px 15px",
                      borderTop: "1px solid #D175B6",
                    }}
                  >
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={handleChangePage}
                      siblingCount={isSmallScreen ? 0 : 1}
                      renderItem={(item) => (
                        <StyledPaginationItem
                          slots={{ previous: ArrowBack, next: ArrowForward }}
                          {...item}
                        />
                      )}
                    />
  
                    <Box
                      sx={{
                        position: "absolute",
                        top: "48%",
                        right: "0.5rem",
                        transform: "translateY(-50%)",
                        // height: "4rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.5rem",
                      }}
                    >
                      <RowsPerPageDropdown
                        value={rowsPerPage}
                        show15
                        onChange={(e) => {
                          setRowsPerPage(e?.target?.value);
                          setPage(1);
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </TableColumnManager>
            </Box>
          </Box>
          </>
          )}
        </>
      ) : (
        <>
          <Box
            sx={{
              position: "relative",
            }}
          >
            <Box
              sx={{
                padding: "0.75rem 0 0 0.75rem",
                // position: 'absolute',
                // top: '0',
                // left: '0',
                // display: 'flex',
                // justifyContent: 'flex-end',
              }}
            >
              <Button
                onClick={closeCreateEventTabHandler}
                sx={{
                  minWidth: "0",
                  background: "none",
                  padding: "0.5rem",
                  boxShadow: "none",
                  border: `1px solid ${getCssVariableHandler({
                    variableName: "--primary-pink-hex",
                  })}`,
                  borderRadius: "50%",
                  "&:hover": {
                    minWidth: "0",
                    background: "none",
                    padding: "0.5rem",
                    boxShadow: "none",
                    border: `1px solid ${getCssVariableHandler({
                      variableName: "--primary-pink-hex",
                    })}`,
                    borderRadius: "50%",
                  },
                }}
              >
                <WestIcon />
              </Button>
            </Box>

            <CreateEvent
              showNavigationButtons={true}
              closeHandler={closeCreateEventTabHandler}
              NavButtonsComponent={CongratulationsNavButtonsVariant2}
              navButtonsComponentProps={{
                closeHandler: closeCreateEventTabHandler,
              }}
            />
          </Box>
        </>
      )}
      {/* Edit event modal*/}
      {/* <EditEventModal
        eventData={editEventModal.data}
        open={editEventModal.status}
        handleClose={() => {
          setEditEventModal({ status: false, data: null });
        }}
        updateEvent={() => setCount((prev) => prev + 1)}
      /> */}
      {/* custom dialog for delete event */}
      <AssignClientModal
        refreshNewEventRequest={refreshNewEventRequest}
        open={open}
        setOpen={setOpen}
        eventInfo={eventInfo}
        isList={true}
      />
      {showEditNoteModal?.show ? (
        <Modal
          open={showEditNoteModal?.show}
          // open={false}
          onClose={() => {
            setShowEditNoteModal({ ...showEditNoteModalInit });
          }}
          // style={{
          //   display: "flex",
          //   justifyContent: "center",
          //   alignItems: "center",
          // }}
          className="modalBox"
        >
          <Box
            sx={{
              width: "40%",
              minWidth: "20rem",
              // height: '50%',
              minHeight: "20rem",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              "@media (max-width:600px) ": {
                width: "97vw",
                minWidth: "90vw",
                overflow: "hidden",
              },
            }}
          >
            <ReusableParentContainer
              style={{
                background: getCssVariableHandler({
                  variableName: "--bg-theme-rgb",
                }),
                width: "100%",
                height: "100%",
                padding: "1rem 2rem",
              }}
            >
              <EditNoteModal
                successCallback={editNoteSuccessCallback}
                closeModalHandler={closeEditNoteModalHandler}
                content={showEditNoteModal?.content}
                // sessionId={showReportedIssueModal?.sessionId}
                // positionId={showReportedIssueModal?.positionId}
              />
            </ReusableParentContainer>
          </Box>
        </Modal>
      ) : null}
      {isUserRole(
        USER_ROLES.SUPERADMIN,
        USER_ROLES.ADMIN,
        USER_ROLES.COORDINATOR,
      ) && (
        <RightClick
          metaData={{
            isArchived: contextMenu?.row?.isArchived,
          }}
          clickEvents={{
            // Restore hidden duplicates here, including drafts with no standalone show page.
            unmarkDuplicate: contextMenu?.row?.isDuplicate === true && isUserRole(USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN)
              ? () => {
                  const row = contextMenu?.row;
                  setContextMenu({
                    status: false,
                    mouseX: null,
                    mouseY: null,
                    row: null,
                  });
                  toggleDuplicateFlow({
                    dispatch,
                    eventId: row?._id,
                    isDuplicate: true,
                    onDone: () => fetchEventsHandler({}),
                  });
                }
              : null,
            archiveEvent: () => {
              dispatch(
                alertDialogAciton({
                  open: true,
                  title: "Warning",
                  message: contextMenu?.row?.isArchived
                    ? "Are you sure, you want to unarchive this event?"
                    : "Are you sure, you want to archive this event?",
                  okLabel: contextMenu?.row?.isArchived
                    ? "Unarchive Event"
                    : "Archive Event",
                  onOk: () => {
                    dispatch(
                      archiveEventAction({
                        payload: {
                          params: {
                            eventId: contextMenu?.row?._id,
                          },
                        },
                        successCallback: () => {
                          fetchEventsHandler({
                            successCallback: ({ res }) => {},
                          });
                        },
                      }),
                    );
                    setContextMenu({
                      status: false,
                      mouseX: null,
                      mouseY: null,
                      row: null,
                    });
                  },
                }),
              );
            },
            editEvent: () => {
              setEditEventModal({
                status: true,
                data: contextMenu?.row,
              });
              setContextMenu({
                status: false,
                mouseX: null,
                mouseY: null,
                row: null,
              });
            },
            deleteEvent: () => {
              setDeleteEventModal({
                status: true,
                id: contextMenu?.row?._id,
              });
              setContextMenu({
                status: false,
                mouseX: null,
                mouseY: null,
                row: null,
              });
            },
            cancelEvent: !contextMenu?.row?.approved
              ? () => {
                  dispatch(
                    alertDialogAciton({
                      open: true,
                      title: "Warning",
                      message:
                        "Are you sure, you want to cancel this event request? This action cannot be undone.",
                      okLabel: "Cancel Event",
                      onOk: () => {
                        dispatch(
                          rejectEventAction(
                            { eventId: contextMenu?.row?._id },
                            () => {
                              fetchEventsHandler({});
                            },
                          ),
                        );
                      },
                    }),
                  );

                  setContextMenu({
                    status: false,
                    mouseX: null,
                    mouseY: null,
                    row: null,
                  });
                }
              : null,
          }}
          contextMenu={contextMenu}
          handleClose={() =>
            setContextMenu({
              status: false,
              mouseX: null,
              mouseY: null,
              row: null,
            })
          }
        />
      )}
      {/* Edit event modal*/}
      {editEventModal?.status && (
        <EditEventModal
          eventData={editEventModal.data}
          open={editEventModal.status}
          handleClose={() => {
            setEditEventModal({ status: false, data: null });
          }}
          updateEvent={() => {
            fetchEventsHandler({});
          }}
        />
      )}
      <CustomDialog
        open={deleteEventModal.status}
        onClose={() => {
          setDeleteEventModal({ status: false, id: null });
          setConfirmPassword("");
        }}
        title="Delete Event"
        message="Are you sure you want to delete this event?"
        okLabel="Delete"
        onOk={() => {
          dispatch(
            deleteEventAction({
              payload: {
                eventId: deleteEventModal.id,
                data: {
                  confirmationPassword: confirmPassword,
                },
              },
              successCallback: () => {
                setDeleteEventModal({ status: false, id: null });
                setConfirmPassword("");
                dispatch(
                  alertDialogAciton({
                    open: true,
                    title: "Success",
                    message: "Event deleted successfully.",
                  }),
                );
                fetchEventsHandler({});
              },
            }),
          );
        }}
        confirmPassword={true}
        password={confirmPassword}
        setPassword={setConfirmPassword}
      />
    </>
  );
};

export default Dashboard;
